module.exports = {
  "+1Wujb": "{num} éléments",
  "+4lD9e": "Nom",
  "+L9lak": "Appliquer le modèle d'alarme",
  "+bRanp": "Veuillez renseigner le nombre maximum de notifications",
  "+d7aNN": "Liste des modèles d'alarme",
  "/COTHZ": "Le nom du module d'alarme ne peut pas être vide",
  "/cqdKk": "Télécharger",
  "/l9tS2": "Non déclenché",
  "/sI6h+": "c'est",
  "03eM6t": "200 éléments/page",
  "0JCY6+": "Déployeur",
  "z9+Z7p": "Sélectionner les balises",
  "0sn8j/": "Veuillez indiquer votre nom",
  "1UXyeT": "Temps de déclenchement",
  "1WymPU": "Sélectionner la valeur de déclenchement de l'alarme",
  "2+X2n8": "Suppression par lots",
  "28oE7E": "Aucun périphérique sélectionné",
  "29A4OA": "Membre de la société",
  "2QzYmY": "Annuler",
  "2rDc7R": "Les règles d'alarme ne peuvent pas être vides",
  "2t0Cct": "Date de déploiement",
  "32AbcK": "Sélectionner une entreprise",
  "36+mbi": "Statut du traitement",
  "3HzQUc": "Exporter JSON",
  "3RVwfq": "Veuillez remplir les commentaires",
  "3aYG4L":
    "Supprimer le modèle d'alarme actuellement appliqué à l'appareil et ne plus surveiller ni envoyer d'alarmes",
  "3qVnoZ": "Nombre d'appareils ({num})",
  "4/e9qs": "Veuillez remplir le nom",
  "4VVrWd":
    "Êtes-vous sûr de désactiver ({name}) le modèle d'alarme ? Après l'avoir désactivé, les nouveaux dispositifs d'alarme ne pourront pas appliquer le modèle.",
  "4vWL+W": "Importer le périphérique",
  "4wi+/p": "Modèle",
  "5SSVAQ": "Nouveau modèle d'alarme",
  "5grmob": "Veuillez renseigner votre adresse email",
  "5p8cBO": "Gestion du compte",
  "60Ixlm": "Nom du modèle d'alarme",
  "6ABIlp": "Statut du déclencheur",
  "6mjOF/": "Réinitialisation par lots",
  "7G1c4h": "Liste des appareils",
  "8PESa6": "Désactiver",
  "919TK9": "Formats pris en charge : xls, xlsx",
  "9Kfib+": "Erreur inconnue",
  "9UefLp": "étiquette",
  i5Nyva: "Non lu",
  ich0wH: "SN de l'appareil",
  wpKIvP: "Lire",
  pGioLb: "Séquence d'appareil SN",
  "wnPTP+": "Entrez le SN de l'appareil",
  B57Wbu: "Aucun périphérique sélectionné",
  BC74I9: "Message d'invite",
  BQcLxf: "Descendre",
  BYbqwY: "Faites glisser le fichier ici ou cliquez pour télécharger",
  BhkglP: "Afficher le jeton",
  BwXapw: "Veuillez contrôler le nom de la catégorie dans les 500 caractères",
  CLqPBU: "Modifier",
  wDqNy1: "Exemple",
  P76mDe: "Gestion synchrone des fichiers",
  "5EJNIu": "Recherche d'équipements dans les entreprises",
  D3lDHK: "Ajouter une règle d'alarme",
  D5HOUz: "Sélectionner le statut",
  E2kRYi: "Activation par lots",
  "EZ+vMa": "Annotation du modèle",
  EwM8Kj: "Etes-vous sûr de vouloir déménager ?",
  Ey9rBq: "Etes-vous sûr de vouloir le supprimer ?",
  F2LJDJ: "Êtes-vous sûr de vouloir supprimer ?",
  F56ZKt: "Sélectionner les membres",
  FEb7U2: "Confirmer",
  "FaJ/jI": "Aucun fichier sélectionné pour l'import",
  FbCeo1: "Valeur de déclenchement",
  FbsCUK: "Téléphone portable",
  FeJVkL: "Ajouter des destinataires supplémentaires",
  "Fr1I/b": "étiquette",
  "G+BH4o": "Êtes-vous sûr de supprimer l'appareil actuel ({name}) ?",
  GKSW97: "Désactivation du lot",
  GQ5EVQ: "Veuillez cocher au moins une case",
  GUMdjP: "Statut de la dernière exécution",
  Gk0Mt5:
    "Êtes-vous sûr de réinitialiser ({name}) le dispositif d'alarme ? Après la réinitialisation, les règles d'alarme continueront à être surveillées.",
  GujK99:
    "Si le contenu du modèle d'alarme est mis à jour ultérieurement, il sera également synchronisé avec l'appareil appliqué",
  HN1dNJ: "Tous les comptes",
  IqkgWZ: "Mot clé",
  "Iwt/8W": "Annotations",
  "J0D5h+": "Heure de début",
  J9jPRL: "Copie réussie",
  JJl2M9: "Exporter",
  JeJAmT: "Renommer",
  Jh62y5: "Tous les appareils",
  Jp7u8z: "",
  LWSLHa: "Rappel chaleureux",
  Ls1X2Z: "Traité",
  "LuP+H0": "Description",
  LwhdsE: "Basculer plusieurs sélections",
  MnTdIi: "Nombre de déclencheurs",
  MvGPdx:
    "Êtes-vous sûr d'activer ({name}) le modèle d'alarme ? Après l'avoir activé, les nouveaux dispositifs d'alarme peuvent appliquer le modèle.",
  N4np50: "Nombre maximum de notifications",
  NTanl8: "Ajouter un modèle d'alarme",
  NW8FV4: "État de commande du périphérique",
  OsMncl: "Non activé",
  "P/eul9": "Non",
  P6YSaZ: "Historique des alarmes",
  PgNsL5: "Déploiement",
  "Py/5UG": "Le nœud exploité n'existe plus, veuillez l'opérer à nouveau",
  "Q2/NzC": "{num} appareils ont été sélectionnés",
  QHhMxE: "Sélectionnez un personnage",
  QV3pnn: "Statut",
  "QavrS/": "Nom de la règle",
  QwHI8Q: "Résultats de la requête :",
  R2D5Dv: "Temps de création",
  R3TTCW: "Modifier le modèle d'alarme",
  S57QRB: "Filtrer par",
  SGDlQ6: "{total} éléments au total",
  T3CtvK: "Le nom de la catégorie ne peut pas être vide",
  TDuPUp: "Déclenché",
  TqDOFU: "Veuillez ne pas envoyer de codes de vérification fréquemment !",
  U2DqqT: "Rechercher une société",
  UBbWUL: "Aucun modèle sélectionné",
  UFjZVV: "Statut du déploiement",
  UUtqvk: "Non traité",
  UcumBq: "Notification d'alarme",
  UtE0dS: "Opération",
  "Uu/nFu": "Supprimer tous les modèles d'alarme appliqués à cet appareil",
  V0RiZp: "Opération réussie",
  VR6zMp: "Etes-vous sûr de vouloir le désactiver ?",
  VRizgn: "Veuillez renseigner votre numéro de téléphone portable",
  ViVQNi: "rôle",
  WeKYMe: "Heure de la dernière commande",
  Wp6QLH:
    "Confirmez-vous la réinitialisation ({name}) de la règle d'alarme ? Après la réinitialisation, la règle d'alarme continuera à être surveillée.",
  "WwRq+y": "Veuillez ajouter un objet de notification d'alarme",
  "X/cNgA": "Supprimer le rappel",
  XFEq9J: "Statut du modèle",
  XG2wHz: "Déploiement réussi",
  XMBOec: "Supprimer la balise",
  XeiAal: "Supprimer",
  XgmTAk: "Numéro de série de l'appareil",
  YBAsWB: "Commande de groupe",
  YpXN8m: "Dernier temps de déclenchement",
  ZETl7o: "Modèle d'alarme",
  ZMUuo8: "Êtes-vous sûr de vouloir l'activer ?",
  ZPSpaL: "Nom du module d'alarme",
  ZUPzqr: "Allumer",
  "Zvt+2g": "Entrepôt",
  aBleoN: "Sélectionner un modèle d'alarme",
  "aN+DgN": "Durée d'activation",
  aiBGBs: "Supprimer avec succès",
  "arp+TQ": "50 éléments/page",
  "bE+h3K": "État de l'appareil",
  bOKDVF: "Basculer la sélection radio",
  bqbDVw: "Requête",
  cDZ00w: "Afficher",
  drCsUI: "Entreprise",
  e8OyHO: "20 éléments/page",
  f7Dpbl:
    "Téléchargez le modèle et améliorez le contenu selon les invites du modèle",
  fz2pkM: "Ce nœud a été supprimé",
  gU4eZD: "Gestion des alarmes",
  ggvI6Z: "Sélectionner tout",
  gomg5W: "Désactiver le rappel",
  gzHM5l: "Date de déclenchement de l'alarme",
  "hDx3/S": "E-mail",
  hMboy7: "Détails de l'état de la commande",
  iKomBu: "Aucune classification pour l'instant",
  ieTzi7: "Détails du modèle d'alarme",
  ifGp4v: "2FA",
  iyOrrD: "100 éléments/page",
  j6IHvr: "Afficher les détails",
  jT6zKT: "Nombre d'appareils",
  jdbKm7: "Objet de notification d'alarme",
  jddlWH: "Le déploiement a échoué",
  kCh5Jz: "indice",
  kG2Etz: "En ligne",
  khyRcw: "Veuillez sélectionner un fichier Excel",
  kwOS33: "Activer le rappel",
  l1fZNE: "Impossible de décocher toutes les cases",
  loTFGc: "Sans nom",
  m0Qdyj: "Échec de la vérification",
  ma6S6y: "Affichage personnalisé",
  "mpeFt+": "Règles d'alarme",
  nH1F3p: "Êtes-vous sûr de supprimer la règle d'alarme actuelle de ({name}) ?",
  nJCPaY:
    "L'utilisateur n'a pas d'adresse e-mail liée et ne peut pas être vérifié",
  nUSeQB: "Aucun compte sélectionné",
  nw8orn: "Nombre de personnes notifiées",
  pBPyFt: "Version Nubis",
  "pV2t/S": "Informations de base",
  pcU9bM: "Ajouter un membre",
  q6qKtH: "Condition de requête :",
  qUKj7E: "Copier",
  "r0/TUu": "OK",
  "r2dEd/": "Réinitialiser",
  s9U9qn: "Définir l'alarme",
  sOIerB: "Non activé",
  sZSyGZ: "Activer",
  srEpKw: "Téléchargement",
  srpWCM:
    "Vérifiez les champs qui doivent être affichés et faites-les glisser pour les trier",
  t2iHNJ: "Mise à jour",
  "tCh+iz": "Délai de déclenchement de l'alarme",
  tLW3W3: "Numéro de téléphone portable",
  tokMPz: "Objet d'exception",
  "uoZwj+": "Créateur",
  v04auv: "Heure de fin",
  w8L9Kj: "Configurer les règles d'alarme",
  wOHHSJ: "Monter",
  wQAiLI: "Réinitialiser le rappel",
  xISm1t: "activer",
  xUjLTE: "Rechercher",
  y9NWzQ: "Liste des dispositifs d'alarme",
  yGWx2z: "Erreur de paramètre",
  yOMNOj: "Oui",
  yReEcE: "Sélectionner la balise",
  yXsHgv: "10 éléments/page",
  yb3AuG: "hors ligne",
  ybGQQ3: "Aucun résultat pertinent",
  "yiO/gL": "Liste de modèles",
  yxPDHk: "Statut de version",
  zH7h1q: "Historique",
  "96Mzoq": "Terminé",
  ByhhM1: "Condition",
  PcCooF: "Valeur de déclenchement de l'alarme",
  RUMaeu: "Veuillez remplir complètement les règles d'alarme",
  h7w4pz: "Aucune donnée pour l'instant",
  nMMNa6: "Nous vous informerons par e-mail, SMS ou système.",
  "nOE0/j": "Recherche d'entreprises et de membres",
  q6WPYA:
    "L'appareil sélectionné contient {num} versions Nubis Free et l'envoi de commandes en groupe ne sera pas possible.",
  "+CP3nr": "Sélectionner une tâche",
  "+gbx50": "Condition d'alarme",
  "+wet4N": "Erreur du code de vérification",
  "/BzHXM": "Sélectionnez le créateur",
  "/SqqyP": "Entrez le numéro de série de l'appareil",
  "0YYUNG": "{num} tags ont été sélectionnés",
  "1M03Dq": "Modèle de planification",
  "1SslIM": "Fermer l'application",
  "1gjtU2": "Dernière heure d'exécution",
  "1sj5Sj": "Supprimer tous les modèles de planning appliqués à cet appareil",
  "2MYr1m": "Connexion",
  "2l+gFk":
    "Êtes-vous sûr d'activer ({name}) le modèle de planification ? Après l'avoir activé, l'appareil peut référencer le modèle.",
  "2opnVU": "Pendant l'exécution",
  "2r/XUW": "Supprimer tous les modèles de planning appliqués par cette balise",
  "3xlnbE": "Heure de commande",
  "47GdDb": "Fermer",
  "5ytYaf": "Nouveau modèle de planning",
  "65DvZ1": "Limite supérieure d'entrée : 4",
  "6x6nu5": "Durée d'exécution réelle",
  "8zN+hZ": "Exécuter l'application",
  "9UZxwP": "Veuillez saisir le code de vérification",
  "9kkcTB": "Supprimer le modèle de planning",
  "9ljNkr": "Renvoyer",
  "A/eXwT": "Supprimer tous les modèles d'alarme appliqués à cette étiquette",
  AyWMlZ: "Ajouter une tâche planifiée",
  BiPxfI: "Ajouter un modèle de planning",
  C6cGK1: "Le nom du modèle de planification ne peut pas être vide",
  EGvInA: "Liste des alarmes de l'équipement",
  Ft60hS: "Appareil Nubis",
  Gwj7xc: "Restaurer les valeurs par défaut",
  H15ECl: "Application de saisie",
  "J3BW/8":
    "Veuillez saisir le code de vérification que vous avez reçu par e-mail",
  KW8qOm: "Sélectionner un modèle",
  LADN1a: "Statut d'exécution de la planification",
  Lfia0v: "Définir le planning",
  NDmD8V: "Etes-vous sûr de supprimer le modèle de planning ({name}) ?",
  OVecAI: "Succès",
  OwtOn5: "Statut total",
  PTc6Gt: "Activer la planification",
  PaMvre: "Liste des règles d'alarme",
  PnYplH: "Équipement",
  RNaGVr: "Liste des échecs des tâches",
  RWBRyt:
    "La carte de répartition des équipements est en cours de construction",
  "RuFFf/":
    "Êtes-vous sûr de désactiver ({name}) le modèle de planification ? Après la désactivation, l'appareil ne peut pas référencer le modèle.",
  SPyEF8: "Sélectionner le mode",
  SwMBFl: "Appliquer le modèle de planning",
  TDSTTj: "Sélectionner un modèle de planning",
  UMU42c: "Sélectionner l'appareil",
  Unvxiq: "Changer de compte",
  WxPZOH: "Exécuter {num} fois",
  WypzMq: "Tâches planifiées",
  X2m4ec: "Désactiver le modèle de planification",
  "YIgP+p": "Liste de planification des appareils",
  LNGTru: "Liste des échecs de planification des appareils",
  YwEzx2: "Vérifiez les champs qui doivent être affichés",
  Z2B362: "Continu",
  ZBDct6: "Échec : {num}",
  ZHAjhZ: "Limite supérieure d'entrée : 30",
  Zr9Dss: "Échec",
  azDNha: "Envoyé avec succès",
  b5l2vN: "Enregistrer",
  b6y8Ai: "Etes-vous sûr de désactiver ({name}) le planning ?",
  bYIKFB: "En cours : {num}",
  "e/6XZC": "Vous n'avez pas reçu le code de vérification ?",
  eAgY2G: "Développer les filiales",
  fl7J8Y: "Messages",
  "gH+Az7": "Désactiver la planification",
  gi4oTZ: "Liste des modèles de planification",
  gplM71: "Quotidiennement",
  "hAd+eG": "Calendrier de planification des équipements",
  "hD7/Lu": "Affichage",
  hYN7oM: "Masquer",
  hfn1Ux: "Succès/Total",
  hkJXyi: "Configurer les tâches planifiées",
  "hkR3E+": "Mode affichage",
  hwlmeB: "Type de cible",
  iN7Lps: "Mode boucle",
  iscUWH: "Terminé : {num}",
  "j/YGZ0": "carte",
  j6Hm96: "Exécution planifiée",
  jNxbTC: "Le code de vérification ne peut pas être vide",
  js3tZs: "Nom du modèle de planification",
  k9dozc: "Durée d'exécution",
  kUagYW: "Historique d'exécution du planning",
  l7IiCY: "Statut de planification",
  "lzP/we": "Téléchargement ORA",
  m1h20o:
    "Si le contenu du modèle de planning suivant est mis à jour, il sera également synchronisé avec l'appareil appliqué",
  "mC2//O": "Afficher le calendrier",
  mFIXSq: "Numéro de série de l'appareil",
  mISQTh: "Détails",
  nGubXb: "Détails du modèle de planification",
  nqPJwo: "pour les balises",
  oCogiy: "commande",
  oY0m24: "utilisateur",
  oirnwv: "Activer le modèle de planning",
  ojz0Ke: "Voir plus >",
  oru5FY: "Modifier le modèle de planning",
  "p+zOzc": "résultat",
  peNVzr: "Toutes les {num} semaines",
  pfGGi0:
    "Supprimer le modèle de planification actuellement appliqué à l'appareil et ne plus l'exécuter",
  pielKO: "Périphérique de démarrage",
  pkYJKs: "Statut d'exécution",
  qhC4wy: "Rechercher un appareil",
  rUHCoM: "Planification des équipements",
  sb1vdX: "En cours",
  u3dVQz: "Hebdomadaire",
  "urr92/": "Sélectionnez le déployeur",
  vovKL8: "Le chemin de l'application ne peut pas être vide",
  "wrU/Kc": "Tous les {num} jours",
  ygAHaf: "Heure d'envoi",
  zvaxmN: "Gestion des horaires",
  "2ffDGT":
    "Êtes-vous sûr de fermer la tâche planifiée ? L'appareil n'exécutera pas le modèle de planification après la fermeture.",
  "D//rZg": "Etes-vous sûr de supprimer l'application du modèle de planning ?",
  E1GPl7: "Propriétaire",
  EwTMGn: "Êtes-vous sûr d'activer ({name}) le planning ?",
  GpzsBd: "Ouvrir les tâches planifiées",
  IM8kXz: "Etes-vous sûr de supprimer l'application de ({name}) ?",
  KXqGQe: "Activation par lots",
  NGe0Cs: "Supprimer les enregistrements d'exécution du planning",
  SkK50H: "Veuillez ajouter une tâche planifiée",
  Trt6ju:
    "Êtes-vous sûr de démarrer la tâche planifiée ? Après le démarrage, l'appareil doit exécuter la tâche planifiée.",
  UiVtQS: "Fermeture du lot",
  "Z56D+X": "Fermer les tâches planifiées",
  aKxrop: "Supprimer l'application du modèle de planning",
  miANEg:
    "Êtes-vous sûr de fermer ({name}) la tâche planifiée ? L'appareil n'exécutera pas la tâche planifiée après la fermeture.",
  ngLF8L:
    "Êtes-vous sûr de supprimer l'enregistrement d'exécution du planning de ({name}) ?",
  nqPOJc:
    "Êtes-vous sûr d'ouvrir ({name}) la tâche planifiée ? Après l'ouverture, l'appareil doit exécuter la tâche planifiée.",
  oV0gpL: "Date de sortie prévue",
  xtHJEE: "Aucun enregistrement sélectionné",
  yifWnc:
    "Etes-vous sûr de supprimer l'enregistrement d'exécution du planning ?",
  "+/R6RX": "Statut de la tâche",
  "35v5wD": "Etes-vous sûr de réinitialiser l'historique des alarmes ?",
  "3QXG/d": "Version Ora",
  "5jpkHg": "Statut en ligne",
  G4XFn6: "Modèle matériel",
  Ko5CPO: "Etes-vous sûr de réinitialiser l'historique des alarmes ?",
  ajVpLe: "Êtes-vous sûr de vouloir supprimer cet historique d'alarmes ?",
  dEXfrL: "Intervalle d'état de santé de l'appareil",
  eCCa0L: "Type de tâche",
  fr4nkj: "Etes-vous sûr de vouloir supprimer l'historique des alarmes ?",
  nzsNwZ: "État de santé de l'appareil",
  qDba8m: "État de l'appareil hors ligne",
  rDRAr0: "Version du système d'exploitation",
  YeF1dY: "Fuseau horaire",
  BC52ne: "Ignoré",
  SbZhau: "La tâche de démarrage doit spécifier un périphérique de démarrage",
  "lsLYU/": "Le nombre maximum de notifications ne peut pas dépasser 10",
  "NM/lRq": "Annuler le téléchargement",
  "3qF993":
    "Vous ne pouvez pas transférer des appareils qui ne font pas partie de votre entreprise actuelle.",
  "6+iYA0": "numéro de série",
  yc6ZUL: "Ora Statut de la dernière mise à jour",
  UA7mv6: "Ora Heure de la dernière mise à jour",
  "fOwU1/": "appartenir",
  jNiwk6: "Etes-vous sûr de supprimer le dispositif d'alarme ({name}) ?",
  "lLa/D3": "Appliquer le type",
  "wk1c/l":
    "Selon la période de mise à jour des niveaux de gris de l'appareil (heure locale)",
  "5+oaTO": "état de la dernière mise à jour de l'image",
  "6pDRb2": "Veuillez entrer un mot de passe valide",
  ANeFu6: "Vérifier le mot de passe",
  GnzEo7: "heure de dernière mise à jour de l'image",
  s7NSze:
    "Veuillez saisir le mot de passe de votre compte avant de confirmer l'opération",
  "9RNrDU": "S'il s'agit d'un périphérique proxy",
  "+TzicH": "Marchand",
  "/CxA3j": "Ajouter un sous-commerçant",
  "4c3uw8": "Supprimer le marchand",
  "5Hy0Qx": "Ne peut être transféré au même commerçant",
  BBpRbn: "Supprimer tous les modèles d'alarme appliqués par ce commerçant",
  DADacD: "Supprimer tous les modèles de planning appliqués par ce commerçant",
  G9WbnV: "Pour les commerçants",
  S1QSWC: "Importer un sous-marchand",
  TYAJpp: "{num} marchands ont été sélectionnés",
  Ve9Ksw: "Transférer le marchand",
  Wzv7kF: "Veuillez sélectionner un marchand",
  h7Yvwt: "Cross-commerçant",
  jAAXdQ: "Marchand d'équipement",
  "kr+7Iy": "Rechercher des marchands",
  tFr3tb:
    "Etes-vous sûr de supprimer le modèle d'alarme ({name}) ? Après suppression, l'application de ce modèle par l'appareil, le commerçant et l'étiquette sera annulée simultanément.",
  uuRzdk: "Attribué au commerçant",
  vD5wnY:
    "Cocher l'appartenance du commerçant signifie que vous avez l'autorisation du commerçant",
  zyMKgy: "Sélectionner un marchand",
  RndUeh: "Durée d'exécution estimée",
  gcHeN9:
    "Veuillez renseigner le nom de l'application du système d'exploitation. Par exemple : Windows:chrome ou Android:com.android.chrome",
  EM8lAi:
    "Selon la période de temps pouvant être mise à jour sur l'appareil (heure locale)",
  "4Regzm": "Liste des marchands",
  "i6kDf/":
    "L'appareil sélectionné contient {num} versions Nubis Free et les commandes de l'appareil ne seront pas possibles.",
  o8tJYm: "Commande de périphérique",
  "+74JfZ": "Exemple : Device_000001_Gaoqiao Merchant_Android",
  "+CLSks":
    "2. Le type de système d'appareil auquel cette règle de dénomination s'applique",
  "+GQdfc": "Mettre à jour le jeton",
  "+m8vFq": "Détails de la règle de dénomination",
  "0KH9Qi": "Type de système d'appareil",
  "0Z908D":
    "Vous ne pouvez sélectionner qu'une seule version d'une même application",
  "0bBO2n": "version",
  "0iTEVO": "Afficher le jeton",
  "12LEcf":
    "Etes-vous sûr de désactiver ({name}) cette règle de dénomination ?",
  "1PtjRr": "Nom du périphérique",
  "2/LdaO": "Stocker les informations de configuration",
  "2V19bd": "Détails du fichier de configuration",
  "2jlHQB": "2. Règles de dénomination par défaut de l'entreprise",
  "3ZtPM3":
    "Si le magasin ne définit pas de règles de dénomination, les règles de dénomination de l'entreprise seront appliquées lors de l'ajout de nouveaux appareils. Si vous ne souhaitez pas les appliquer, vous pouvez désactiver les règles suivantes",
  "3qgucc": "Définir le fuseau horaire manuellement",
  "5FboZ/": "Type",
  "5ZgUEM": "Modifier le modèle de configuration",
  "5d3yZi": "Durée effective",
  "5noX9X": "Nom du fichier de configuration",
  "6Ty5/G": "Publié avec succès",
  "7NmXNy": "Informations sur le programme actuel",
  "7PkBL6": "Activer les mises à jour silencieuses",
  "7ip592": "1. Nom de la règle de dénomination",
  "88CuCZ":
    "3. Créez une méthode de dénomination pour les appareils enregistrés dans ce magasin (remplissez automatiquement les noms des appareils)",
  "8WYGi+": "Êtes-vous sûr de vouloir copier ?",
  "8huAxo": "Ajouter une nouvelle règle",
  "8pB1C7": "Ajouter une application",
  "8u3CYe": "Nom de la règle de dénomination",
  "8zQ4So": "ID du paquet :",
  "96c3gX": "Formater",
  "9iKk2b": "Numéro de départ",
  AFZDo7: "Historique des installations",
  B0WqD0: "1. Période de mise à jour de l'appareil (heure locale)",
  BqUpjt: "Veuillez remplir le nom du package, tel que com.android.chrome",
  "CM76+/":
    "Êtes-vous sûr d'activer ({name}) ce modèle ? Après l'avoir activé, l'appareil peut référencer ce modèle",
  CPTAAj: "Nombre naturel croissant",
  CqlH6G: "Appliquer la liste des magasins",
  "D/Yid+": "Activer ou non",
  D2KnIQ: "Magasin associé avec succès",
  DpnauN: "heure",
  Fi4xFb: "Télécharger l'application Android avec succès",
  G9APSK: "Modifier les règles de dénomination",
  GRfLaO: "Nom de l'application",
  HDYjnT:
    "La version de l'application actuellement sélectionnée est inférieure à l'application existante, ce qui peut entraîner l'échec de l'installation de l'application. Veuillez confirmer si l'application est correctement sélectionnée. Si vous devez installer une application avec une version inférieure, vous pouvez vérifier pour supprimer le programme d'origine puis l'installer .",
  HOHQFs: "Le nom de la règle de nommage ne peut pas être vide",
  "HdxQ2/":
    "Fichiers de configuration liés au magasin et règles de dénomination",
  "I/k8FH": "Libérer",
  IyhhzI: "Créer un fichier de configuration",
  Kj5TRg: "Nombre d'appareils à installer",
  "L4w/Vo": "Dernière version",
  MI3yI1: "Téléchargement de {percentCompleted}%",
  MRe8Q9: "Numéro de version :",
  NrEurQ: "Télécharger Mbps",
  Nrx60r: "Télécharger Mbps",
  OCp4OD: "Afficher le fichier de configuration",
  PDFXBi: "Publier maintenant",
  PkLYZS: "Règles de dénomination des appareils",
  PlNIQ9: "Paramètres système",
  "Q+0CDu": "Ajouter une règle de dénomination",
  Q5vbU5: "Les ID des packages sont incohérents",
  QpOtgZ: "Nom du magasin",
  R9TpN6: "Durée d'installation estimée",
  RY4VVr: "Téléchargeur",
  RyXQqJ: "Durée de téléchargement",
  UfxykZ: "raison",
  Unr58u: "Heure de mise à jour",
  Uzdb6l: "Type de périphérique :",
  Vd3wZV: "Dans l'ensemble",
  VqEr9u: "Appliquer le nombre de magasins",
  WdyIyo: "Durée de fonctionnement",
  WfS4rv: "Opérateur :",
  "XLdI1+": "Force Wi-Fi",
  XnimdQ: "Windows",
  Ym4SPE:
    "Sélectionnez l'heure de publication (durée d'exécution du périphérique)",
  ZWN1C0: "Êtes-vous sûr d'activer ({name}) cette règle de dénomination ?",
  ZdO12B: "Appliquer le magasin",
  ZtZ7Yw: "Nom du programme",
  aHlr3k: "Supprimer",
  akvGrq: "Règles de configuration",
  aqQg0p: "zone",
  bMdSkq: "Enregistrement du test de vitesse du réseau",
  batMBC: "Êtes-vous sûr de vouloir supprimer le modèle ({name}) ?",
  bsjenW: "Activer les règles de dénomination",
  cX08hK: "Aucune donnée sélectionnée",
  cawvIS: "Heure de la dernière mise à jour",
  cijnrq: "Périphérique installé",
  d8xSfX: "code de version",
  dGBGbt: "Tous",
  dRYBRc: "Numéro de version : {version}",
  "devicesList@1": "Sélectionner tous les appareils",
  "devicesList@2": "Sélectionner tous les appareils",
  eUNh5K: "Périphérique à installer",
  "ecTX+c": "Le nom du programme est requis",
  eeCxuz: "Type de système d'exploitation",
  epaa3H: "Ajouter des règles de dénomination",
  evJP5c: "Règles de dénomination",
  fX0dsH: "Version :",
  "fje/m/": "Nom du modèle :",
  fq3WGG: "Gestion des fichiers de configuration",
  gQ7kPU: "Android",
  gnNjS5: "Nom de l'appareil personnel",
  gyHdsW: "Modèle de configuration",
  "gyh+d1": "Réseau câblé",
  hDmGQl: "Vérifier le code de version",
  hqGPDw: "Activer le format 24 heures",
  hxy4wV: "Analyse",
  i5JzAA: "Statut :",
  i5MLJc: "Heure de la dernière mise à jour : {lastUpdate}",
  ie9Iom: "Afficher le modèle de configuration",
  ifAmoA: "Modèle de fichier de configuration",
  imhWD8: "Paramètres de téléchargement",
  iroVTo: "Paramètres de l'entreprise",
  j2kqd8: "Supprimer les règles de dénomination",
  j3QWSE:
    "Le nombre de départ pour l'incrémentation d'un nombre naturel ne peut être qu'un entier positif",
  jKzbw6: "Modifier les paramètres",
  "jN5tO+": "Code de version : {versionCode}",
  "jhfb/7": "Enregistrement réussi",
  k7dy8j: "Fichier de configuration associé",
  kH9MHe: "Désactiver les règles de dénomination",
  kkLQie: "magasin associé",
  "ksb/lB": "Supprimer ou non le programme original",
  l0mW6t: "Dernière heure de mise à jour",
  mRHwkp:
    "Êtes-vous sûr de désactiver ({name}) le modèle ? Après la désactivation, l'appareil ne peut pas référencer le modèle",
  "mYa6W/": "Texte personnalisé",
  "mml+gT": "Sélectionner une application",
  mn0ceu: "Il y a des règles de configuration en double, veuillez les ajuster",
  n1yIyi: "Durée d'installation",
  nDwIwd: "Publié",
  nLERtc: "Mettre à jour l'application Android",
  o9bMHL: "taille",
  oC6GBl: "Application Android",
  "oFt+cN": "Test de vitesse du réseau",
  ovdKZi: "Impossible d'installer le numéro de périphérique",
  "p/3Nn5": "Réseau mobile",
  qS0aFJ: "Gestion des applications",
  qUiH5y: "Les règles de configuration ne peuvent pas être vides",
  qjtl3b: "Activer les mises à jour du système",
  "qqwM/t": "Fichier de configuration",
  rdEPl7: "Impossible d'installer le périphérique",
  rsAvN6: "Nom du programme :",
  rw3uGa: "Nouveau modèle de configuration",
  "s+aIlP": "Rechercher le nom du magasin",
  saeFbf: "Fichier",
  t8R6VW: "ID du package : {package}",
  tWcCoB: "Date du test de vitesse",
  twpxdo: "Télécharger une application Android",
  "u/NB+Y": "ID du paquet",
  vDCwZ9: "Télécharger le fichier",
  vLW90z: "Etes-vous sûr de supprimer la règle de dénomination ({name}) ?",
  vr5TVT: "Veuillez entrer",
  wiSRo9: "Nombre d'appareils installés",
  "xE1H+X": "Paramètres",
  xdjVt1: "Nom du modèle non renseigné",
  xlNcvg: "Dernière mise à jour :",
  xrQzKh: "Veuillez remplir le nom de l'application, tel que Chrome",
  xwYDb8: "Code de version :",
  ydktLD: "délimiteur",
  zeMk2K: "Brouillon",
  zok1hp: "Emplacement C",
  zrIs7T: "Heure de la dernière mise à jour",
  "a++4i0": "L'heure de publication doit être supérieure à 24 heures",
  "3JwoQQ":
    "Le téléchargement a échoué et l'application ne peut pas l'analyser.",
  "9Fvzl9": "Libération par lots",
  OiP4rW:
    "Il existe actuellement un fichier de configuration associé à une boutique, veuillez vérifier.",
  b95U3r: "Liste des fichiers de configuration",
  nJetAr: "Format non pris en charge.",
  lPA1qT: "Cette configuration concerne uniquement des appareils spécifiques",
  oXfYag: "Le code de version existe déjà, veuillez le télécharger à nouveau",
  "k+a7BC": "Effectuer une mise à jour silencieuse",
  "/k2Fs5": "Règles de dénomination de la configuration",
  e2ys3T: "Stocker les détails de la configuration",
  yy7EDI: "Télécharger",
  "+cCXuw": "Sélectionner une image dans un fichier",
  "0cZQXI": "Ajouter par identifiant de package",
  "0xm1Zu": "Combinaison de touches de verrouillage",
  "33bmiC": "Le répertoire parent n'existe pas",
  "4UcMA+": "Ajouter du Wi-Fi",
  "4ia8sI": "Contrôle des fonctions",
  "4o167y": "La longueur du texte personnalisé ne peut pas dépasser 30",
  "66awCH": "Actualiser",
  "C+cw77": "Configuration du fond d'écran",
  E6G3sr: "Mode kiosque",
  "FQK+2G": "Synchronisation des fichiers",
  FWlWJR: "Afficher les informations du magasin",
  HI1PTY: "Entrez le chemin du dossier",
  HNavdr: "Nom de la société",
  JPIKnb: "Écran d'accueil",
  MufYuw: "Écran de verrouillage",
  NPjnPZ: "Luminosité",
  "Pdx/YD": "Mot de passe",
  Pg5mqb: "Mode paysage",
  QSjBm5: "Le fichier n'existe pas",
  UH1kCc: "Ajouter",
  UduVZX: "Sélectionner un fichier",
  Usn1oq: "Mode portrait",
  "Ymq1/H": "Nom du dossier du périphérique",
  YzG9Iw: "Liste noire",
  ZK1d6f: "SSID",
  bGGvOS: "Sélectionner une image",
  c8uKl6: "Wi-Fi",
  dZlNkV: "Ajouter une configuration",
  dmEBpU: "Configuration de la synchronisation des fichiers",
  foT1aq: "Progression actuelle du téléchargement :",
  g5Pknn: "La taille du fichier dépasse la limite",
  gltp3e: "Désactiver les notifications Windows",
  gweUAO: "Verrouiller l'interface USB",
  nxeBGd: "Exemple :",
  o8HwKf: "Nom du fichier",
  rULuF3: "Si seules les connexions réseau suivantes sont autorisées",
  tIm58E: "Arrêter",
  tR69qg: "Langue d'affichage Windows",
  tnYpSo: "Demande de détection envoyée avec succès",
  xNeD5U: "Annulé",
  xiwfUp: "Volume",
  znna6r: "Enregistrer les informations",
  "+UT6Us": "Zimbabwe",
  "+cSl6d": "Pays-Bas",
  "+vx0UI": "Îles Salomon",
  "+vz4Gy": "Sierra Leone",
  "/1g/gd": "Kiribati",
  "/EzG+0": "Montserrat",
  "/ZaEbq": "Haïti",
  "07BMT/": "Algérie",
  "0E6+/f": "Guam",
  "14axoc": "Îles Falkland",
  "1BFTBO": "Cuba",
  "1GLoiG": "Géorgie",
  "1Z3cpQ": "Côte d'Ivoire",
  "1qc1Bb": "Lettonie",
  "217kis": "Rwanda",
  "2c/STs": "Moldavie",
  "3B2kCX": "Îles Féroé",
  "3Nlsp9": "Slovaquie",
  "3a17nf": "Îles Cook",
  "41lx/9": "Afghanistan",
  "4KMP9f": "Congo",
  "4obEtL": "Togo",
  "5w+tOJ": "Albanie",
  "62Z8c1": "Palaos",
  "6JR/Y7": "Irlande",
  "6LZPqX": "Samoa",
  "6Mnz8p": "Mauritanie",
  "6NPwCy": "Syrie",
  "6f8kym": "Irak",
  "6qdPnx": "Tunisie",
  "7KZ6vz": "Venezuela",
  "7hGupC": "Lituanie",
  "7hNQVL": "Philippines",
  "7p85Tc": "Curaçao",
  "8m5tda": "Égypte",
  "8y7qAE": "République centrafricaine",
  "98qFTO": "Jersey",
  "99fbLn": "Uruguay",
  "9T1JPo": "Malte",
  AD5RPE: "Guinée équatoriale",
  AKnToQ: "Tchad",
  "AO/9GT": "Finlande",
  AYs4yh: "Madagascar",
  Ai6HyC: "Ouganda",
  AksTq6: "Antigua-et-Barbuda",
  ArbweL: "Jordanie",
  AzRGCX: "Allemagne",
  "B/oRh5": "États fédérés de Micronésie",
  BcJbbP: "Qatar",
  Bm5GdP: "Taïwan",
  MRbe2A: "Taïwan",
  BwMY6I: "Sahara occidental",
  BxT2qw: "Tokelau",
  C0YR5J: "Turkménistan",
  C2pikc: "Soudan du Sud",
  C7RUR5: "Nauru",
  CKu8W1: "Niue",
  CYSGlA: "Estonie",
  "D/Hl19": "Martinique",
  DPthJ5: "Luxembourg",
  Dxf50E: "Comores",
  EMaGPN: "Somalie",
  "Eihfz+": "Pakistan",
  Eul4yJ: "Italie",
  F0BTvX: "Réunion",
  FsQ2Ph: "Îles Mariannes du Nord",
  FzXhJn: "Vatican",
  GRDGdf: "Nouvelle-Calédonie",
  "HF/NiY": "Arménie",
  HN9EHr: "Corée du Sud",
  HTqMY5: "Roumanie",
  HZs8KL: "Burkina Faso",
  I2RkrK: "Cambodge",
  I7Erl3: "Maroc",
  IGBRed: "Azerbaïdjan",
  IPfyBg: "Iran",
  IbG9YJ: "Île Norfolk",
  "IrME/4": "Macao",
  XeQT0P: "Macao",
  J1oSvz: "Îles Vierges américaines",
  JIPBj1: "Jamaïque",
  JIWrkV: "Canada",
  JJhl02: "République démocratique du Congo",
  JOJTuh: "Costa Rica",
  JddSbX: "Dominique",
  L7PjzJ: "Île Christmas",
  LShUE0: "Bhoutan",
  "Le+IiI": "Macédoine du Nord",
  LeMbDw: "Zambie",
  LfkgD6: "Australie",
  Lszars: "États-Unis",
  M16xFB: "Brunei",
  MMzrYK: "Liechtenstein",
  MTVChl: "Tonga",
  MXueJK: "Andorre",
  MYneOz: "Djibouti",
  MZwu6r: "Îles Heard-et-MacDonald",
  MbV1M9: "Malaisie",
  MkBrsn: "Paraguay",
  MwNlM3: "Burundi",
  MyB1Vf: "Arabie saoudite",
  NcwUGt: "Israël",
  OZFYbQ: "Vanuatu",
  OZyB9b: "Bosnie-Herzégovine",
  Oc4oig: "Bolivie",
  OhEAqA: "Grèce",
  Oql6Jb: "Portugal",
  PB00mS: "Wallis-et-Futuna",
  PBGuz3: "Pologne",
  PIBLYF: "Hong Kong",
  "1ObLsW": "Hong Kong",
  PIHPBR: "Saint-Martin (partie française)",
  PjOc8o: "Biélorussie",
  "Q+FGAs": "Islande",
  "Q5QY0+": "Îles Caïmans",
  Q5U8nY: "Samoa américaines",
  QA9U89: "Territoire britannique de l'océan Indien",
  QRUdeg: "Mexique",
  QxRaqi: "Danemark",
  RfQSLo: "Corée du Nord",
  RlB4rB: "Géorgie du Sud-et-les Îles Sandwich du Sud",
  RsWzOr: "Hongrie",
  RzKiE0: "Porto Rico",
  SEJjjI: "Antarctique",
  SLmrMX: "Bulgarie",
  T6qzNm: "Laos",
  Tb6AtC: "Émirats arabes unis",
  To4yI6: "Gambie",
  TqXGpl: "Belize",
  UQHsPm: "Cap-Vert",
  UZmEHG: "Mongolie",
  Ulf4Sq: "Inde",
  VCRq6v: "Îles Pitcairn",
  VIFtwp: "Cameroun",
  VTEHKS: "Guinée-Bissau",
  VWg1hF: "Svalbard et Jan Mayen",
  VhGXkw: "Îles Åland",
  W2fcGi: "Suriname",
  W9gKgU: "Seychelles",
  WAl9tj: "Timor oriental",
  "WH+mo5": "Ouzbékistan",
  WJAfY4: "Tuvalu",
  WobBPP: "Libéria",
  XfoqmV: "Salvador",
  XoOuKT: "Kazakhstan",
  YINkHp: "Serbie",
  YMjT8q: "Singapour",
  "Z+fptr": "Colombie",
  ZHe4St: "Indonésie",
  ZRhaI4: "Barbade",
  ZgLO7j: "Liban",
  a9nZYf: "Île Bouvet",
  aNVBIV: "France",
  afgUkt: "Trinité-et-Tobago",
  ahaefV: "Chine",
  b8Yur0: "Bénin",
  bCl9eg: "Vietnam",
  bKHwtk: "Bangladesh",
  bQkGVT: "Fédération de Russie",
  "cio5m/": "Nouvelle-Zélande",
  "d+SgS7": "Nicaragua",
  d97FOT: "Papouasie-Nouvelle-Guinée",
  dUeWgE: "Fidji",
  dXFo2O: "Norvège",
  dcfcTW: "Saint-Pierre-et-Miquelon",
  dyBAW0: "Sénégal",
  eNa9WG: "Sainte-Hélène",
  eX9WT0: "Saint-Marin",
  eiecNW: "Lesotho",
  eu7j6G: "Monténégro",
  f6i4Ch: "République dominicaine",
  fSGNZz: "Belgique",
  fe4fox: "Soudan",
  fp4MWN: "Japon",
  g44w8D: "Royaume-Uni",
  gIZauu: "Guatemala",
  gb8v87: "Turquie",
  h70zPD: "Espagne",
  hB6jsF: "Chypre",
  hBpMeF: "Îles Marshall",
  hC0etv: "Chili",
  hLeEYi: "Saint-Vincent-et-les-Grenadines",
  hrmyDn: "Tanzanie",
  htLGF6: "Bonaire",
  htNRZG: "Monaco",
  hy4yn7: "Kirghizistan",
  iJsE6u: "Mali",
  iVyVIA: "Guernesey",
  iYdC7o: "Népal",
  icfTwL: "Sri Lanka",
  icoYQF: "Terres australes et antarctiques françaises",
  ipoOkJ: "Niger",
  j2GbDK: "Sao Tomé-et-Principe",
  "j83TV+": "Île de Man",
  jHmcI7: "Guinée",
  jKdq05: "Aruba",
  "jZLo+u": "Yémen",
  kCwSgm: "Suède",
  lAVHXj: "Gabon",
  lc0eVA: "Saint-Barthélemy",
  ljBSDy: "Bahreïn",
  mIgnTu: "Bermudes",
  mdbt1h: "Grenade",
  n1eYYR: "Croatie",
  n6sdJi: "Nigeria",
  nU0AoJ: "Maurice",
  nbVGOe: "Guyana",
  ncprFv: "Palestine",
  nfMTZ9: "Libye",
  "oC/YmL": "Angola",
  oJA0AV: "Ukraine",
  ofe1Jv: "Slovénie",
  ox0SUk: "Érythrée",
  pG9dnN: "Guyane française",
  pGsPfz: "Tadjikistan",
  "prG89+": "Saint-Martin (partie néerlandaise)",
  "qKL/I7": "Équateur",
  qhRoDt: "République tchèque",
  r0r576: "Autriche",
  riK5Od: "Mayotte",
  "s/ZbGB": "Gibraltar",
  sVaevR: "Polynésie française",
  sgg3ZA: "Kenya",
  srKhxN: "Bahamas",
  ssKHGM: "Groenland",
  swmjZg: "Thaïlande",
  "tUisY+": "Ghana",
  u3ws3s: "Afrique du Sud",
  u9cEKj: "Saint-Christophe-et-Niévès",
  uPO36O: "Myanmar",
  uY8iM9: "Mozambique",
  ufZlit: "Panama",
  ufyzs9: "Sainte-Lucie",
  v8IwQb: "Argentine",
  vPS1uD: "Pérou",
  vTEjni: "Malawi",
  vcSBZu: "Brésil",
  vixhhG: "Maldives",
  "wL/u2o": "Îles Turques-et-Caïques",
  "wYCJ++": "Eswatini",
  "we/YPm": "Oman",
  xFrFSm: "Namibie",
  xV0lln: "Îles Vierges britanniques",
  xepQSL: "Îles Cocos",
  xk4ByO: "Guadeloupe",
  xwICWz: "Suisse",
  yC4n0v: "Koweït",
  yKWAek: "Anguilla",
  yLlbwi: "Botswana",
  zhs13i: "Honduras",
  zw39MM: "Éthiopie",
  "+31PFz": "Asie/Urumqi",
  "+6yBji": "Asie/Bangkok",
  "+CgfU2": "Pacifique/Efate",
  "+POdLR": "Europe/Volgograd",
  "+VqRkg": "Amérique/Kentucky/Monticello",
  "/+Dhy+": "Amérique/Sao_Paulo",
  "/D9zXZ": "Atlantique/Reykjavik",
  "/UGQnF": "Amérique/Nome",
  "0DYv/B": "Afrique/Nairobi",
  "0HnaGc": "Pacifique/Kwajalein",
  "0R8CQs": "Europe/Budapest",
  "0xV9JO": "Amérique/Argentine/La_Rioja",
  "1H4FmE": "Europe/Uzhgorod",
  "1mv3LM": "Asie/Chita",
  "1pl9Su": "Afrique/Tripoli",
  "1sEPCz": "Asie/Tokyo",
  "1ua619": "Europe/Prague",
  "23aBJh": "Amérique/Denver",
  "2DXZtH": "Europe/Copenhague",
  "2OWj6s": "Asie/Beyrouth",
  "2WXSh8": "Asie/Karachi",
  "2qYhi8": "Asie/Hong_Kong",
  "2s/Mlc": "Asie/Kamchatka",
  "2zQAXL": "Europe/Chisinau",
  "327IN3": "Amérique/Yakutat",
  "339CIL": "Amérique/Belize",
  "3Lz3cq": "Pacifique/Enderbury",
  "40b51E": "Amérique/Miquelon",
  "4AZ4gQ": "Amérique/Argentine/Salta",
  "4D94K+": "Antarctique/Casey",
  "4NXksL": "Europe/Lisbonne",
  "4XF+Io": "Amérique/Tegucigalpa",
  "4l3qM7": "Pacifique/Nouméa",
  "4neOsl": "Amérique/Danmarkshavn",
  "4wb1r/": "Europe/Luxembourg",
  "5M8Wkq": "Amérique/Argentine/Jujuy",
  "5oeyFi": "Amérique/Argentine/Rio_Gallegos",
  "5xwaJJ": "Pacifique/Funafuti",
  "6/dk2l": "Europe/Simferopol",
  "6Rz5js": "Afrique/El_Aaiun",
  "6XgRmz": "Asie/Hovd",
  "6d5tvh": "Amérique/Boa_Vista",
  "6wYqzG": "Pacifique/Wake",
  "71fHGN": "Amérique/Guyana",
  "7Q7WxK": "Amérique/Guatemala",
  "7WBtG1": "Pacifique/Majuro",
  "7euHXg": "Pacifique/Bougainville",
  "7jiQ+M": "Asie/Taipei",
  "82GEmf": "Pacifique/Nauru",
  "8DjTJi": "Pacifique/Fakaofo",
  "9Fhwtp": "Afrique/Monrovia",
  "9TfEAv": "Asie/Dacca",
  "9UC6g0": "Asie/Macao",
  "9xN38t": "Asie/Riyad",
  A1qgI0: "Amérique/Campo_Grande",
  A8Tpo2: "Afrique/Le_Caire",
  ADtcg9: "Amérique/Indiana/Petersburg",
  AQnn4z: "Asie/Qatar",
  AX2M6K: "Afrique/Casablanca",
  ApEhaf: "Antarctique/Vostok",
  "BsRS+L": "Afrique/Lagos",
  "CIpc+3": "Asie/Rangoon",
  CJgAlM: "Amérique/Argentine/Buenos_Aires",
  CMi686: "Europe/Samara",
  CRI2Ve: "Pacifique/Chatham",
  CezJKN: "Amérique/Santiago",
  "Cs/zIo": "Pacifique/Marquises",
  CvKLCn: "Pacifique/Tongatapu",
  CwyqPj: "Afrique/Accra",
  D1tmTQ: "Amérique/North_Dakota/Center",
  D55vg4: "Afrique/Tunis",
  DAlYN5: "Europe/Istanbul",
  DCrzIX: "Europe/Andorre",
  DDqHds: "Afrique/Khartoum",
  DQsykN: "Amérique/La_Havane",
  DVZRDC: "Europe/Oslo",
  DcYI27: "Afrique/Maputo",
  "EGDZo+": "Asie/Srednekolymsk",
  EcRGq9: "Asie/Dubaï",
  EgIxeE: "Amérique/Jamaïque",
  "EnTK+r": "Amérique/Chicago",
  EqvKbF: "Amérique/Cuiaba",
  F0y8e9: "Amérique/Los_Angeles",
  F465cE: "Europe/Helsinki",
  F6OWRn: "Pacifique/Port_Moresby",
  FDGDXD: "Europe/Kiev",
  FEnpn4: "Europe/Berlin",
  FeFqOa: "Asie/Choibalsan",
  "G0/1QH": "Amérique/Paramaribo",
  "GHrEk+": "Asie/Ho_Chi_Minh",
  Gcuin4: "Asie/Oulan-Bator",
  "H+kwCw": "Asie/Brunei",
  "H/TECz": "Asie/Séoul",
  H11GhT: "Asie/Khandyga",
  HD7dNh: "Asie/Qyzylorda",
  HDlqGj: "Amérique/Argentine/Tucuman",
  "HSm zBV": "Amérique/Argentine/San_Luis",
  I2fe6r: "Asie/Hébron",
  ID5HGa: "Pacifique/Guam",
  "IRsI+H": "Asie/Makassar",
  IVs8gT: "Océan Indien/Maurice",
  "IYKKU/": "Asie/Erevan",
  IYSP57: "Amérique/Santarém",
  JGg252: "Asie/Dili",
  "JJJ+wW": "Pacifique/Wallis",
  JTTFhT: "Pacifique/Kosrae",
  KBQ98i: "Europe/Sofia",
  L6RwvT: "Amérique/Scoresbysund",
  LFkBwb: "Asie/Kuala_Lumpur",
  LGJGKo: "Amérique/Indiana/Winamac",
  LepYst: "Amérique/Argentine/San_Juan",
  LrC3cb: "Afrique/Johannesburg",
  M74J18: "Pacifique/Apia",
  "MS/dmQ": "Europe/Vilnius",
  MYvQtB: "Pacifique/Pohnpei",
  MhFcna: "Asie/Aktau",
  MpIqyW: "Asie/Novossibirsk",
  "N69J/J": "Amérique/Cayman",
  N7RBEQ: "Europe/Paris",
  "NLL9E/": "Asie/Singapour",
  Nap8NB: "Amérique/La_Paz",
  NhLpaB: "Asie/Gaza",
  NwiC8y: "Asie/Bakou",
  OPz5aV: "Europe/Varsovie",
  "OSP/DU": "Amérique/Araguaína",
  "OoH/k4": "Europe/Malte",
  OqlGXK: "Atlantique/Féroé",
  OtFyGC: "Europe/Zaporijia",
  P9EyMh: "Asie/Almaty",
  PRo9ZX: "Amérique/Grand_Turk",
  Pbr43k: "Pacifique/Gambier",
  PdnZvE: "Amérique/Indiana/Knox",
  Phhnuu: "Pacifique/Guadalcanal",
  "PlA+93": "Amérique/Anchorage",
  "Q+QFi7": "Amérique/Panama",
  Q0Nwql: "Amérique/Nassau",
  Q2hC7E: "Asie/Anadyr",
  RTFf0R: "Asie/Tachkent",
  RVtTvI: "Amérique/Bogotá",
  RcUwWS: "Europe/Tirana",
  Rfu8ru: "Amérique/Juneau",
  RzRPhx: "Asie/Téhéran",
  SRDvbw: "Océan Indien/Christmas",
  SkSGFq: "Amérique/Asunción",
  SqYr66: "Pacifique/Chuuk",
  T7X3nR: "Amérique/Costa_Rica",
  TnMEvg: "Europe/Riga",
  TnQgWT: "Océan Indien/Cocos",
  UE61nU: "Asie/Jakarta",
  UEbt0M: "Europe/Athènes",
  UjOTtz: "Europe/Monaco",
  VlcnXa: "Atlantique/Açores",
  WICb5K: "Asie/Magadan",
  "WJ+FQF": "Asie/Tbilissi",
  WTSjw5: "Pacifique/Pago_Pago",
  WUi6ng: "Asie/Kuching",
  WX1P13: "Antarctique/Davis",
  Wb2LCw: "Antarctique/Rothera",
  Wg0kce: "Amérique/Indiana/Vincennes",
  WhpVLY: "Amérique/Guayaquil",
  Wq4Z0k: "Amérique/Belém",
  XK8hFK: "Amérique/Rio_Branco",
  XLgiC3: "Pacifique/Norfolk",
  XN4sjj: "Asie/Samarcande",
  XuXXK5: "Amérique/Récife",
  YOJC0Y: "Amérique/Indiana/Marengo",
  Yux40Y: "Antarctique/Palmer",
  "Z+d4VE": "Europe/Amsterdam",
  ZOXOj5: "Antarctique/Mawson",
  "aKg/xg": "Antarctique/Troll",
  "aqHEW/": "Afrique/Alger",
  aqZ1dw: "Pacifique/Galápagos",
  aylTTV: "Amérique/Curaçao",
  "b5+eh2": "Asie/Bagdad",
  b5GT3E: "Afrique/Bissau",
  bf8oMi: "Pacifique/Kiritimati",
  bkKBAQ: "Asie/Pontianak",
  c5lOtj: "Asie/Vladivostok",
  cCvy0S: "Amérique/Caracas",
  ciyA6X: "Asie/Manille",
  cl18LV: "Asie/Oust-Nera",
  d6W7pe: "Europe/Moscou",
  dw9A9j: "Amérique/Argentine/Mendoza",
  e77Cv2: "Asie/Yakoutsk",
  e88zL2: "Asie/Nicosie",
  eDz3Tw: "Amérique/Adak",
  eJqVsD: "Europe/Gibraltar",
  "eR7v+R": "Amérique/North_Dakota/Beulah",
  ekhdTj: "Asie/Jayapura",
  "f6G4/S": "Pacifique/Auckland",
  f6r66H: "Amérique/Menominee",
  fJpD6E: "Afrique/N'Djamena",
  fqXfBN: "Europe/Rome",
  "fxAR+x": "Asie/Oral",
  g2HLMh: "Antarctique/Syowa",
  gU3Odo: "Amérique/New_York",
  "gibo/e": "Europe/Vienne",
  gln1VX: "Amérique/El_Salvador",
  guiUEK: "Europe/Bucarest",
  gycX1L: "Amérique/Noronha",
  h5YZ1i: "Europe/Bruxelles",
  hI5EVU: "Océan Indien/Réunion",
  hKq7PN: "Europe/Kaliningrad",
  hL3apR: "Amérique/Lima",
  hZiOxa: "Amérique/Puerto_Rico",
  hdgzx5: "Pacifique/Pâques",
  hrq9xi: "Europe/Minsk",
  iBXv4d: "Amérique/Metlakatla",
  inPmEU: "Europe/Tallinn",
  jRwF7m: "Amérique/Phoenix",
  jaNloj: "Amérique/Maceió",
  jtTALf: "Pacifique/Honolulu",
  k6R7DN: "Amérique/Fortaleza",
  kLf0tS: "Amérique/Détroit",
  lAz3SQ: "Asie/Bichkek",
  lNijTx: "Atlantique/Stanley",
  m5vKwe: "Asie/Calcutta",
  mXs7zw: "Amérique/Sitka",
  mnvAEu: "Amérique/Indiana/Tell_City",
  n8UW9y: "Asie/Iekaterinbourg",
  nYFNxR: "Asie/Sakhaline",
  o5Rywj: "Amérique/Argentine/Catamarca",
  oYmVJJ: "Asie/Krasnoïarsk",
  ocqIaV: "Océan Indien/Chagos",
  ocqwXs: "Asie/Omsk",
  okHgMB: "Asie/Douchanbé",
  pKp9LP: "Amérique/Indiana/Vevay",
  pNrCwc: "Amérique/Manaus",
  pQ5zcx: "Amérique/Argentine/Ushuaïa",
  pcGYLU: "Amérique/Thulé",
  pvDJax: "Amérique/Barbade",
  "q5++81": "Europe/Londres",
  q7mJWt: "Amérique/Boise",
  "qSxe/X": "Europe/Zurich",
  rB9Ewl: "Asie/Aqtöbe",
  rIY0ZR: "Océan Indien/Maldives",
  rZTr8Y: "Amérique/Indiana/Indianapolis",
  rhN321: "Amérique/Nuuk",
  rslOL6: "Pacifique/Tarawa",
  rwZktH: "Amérique/Argentine/Córdoba",
  s2obSj: "Pacifique/Palaos",
  s3GZlv: "Amérique/Port_of_Spain",
  slYOe6: "Amérique/Cayenne",
  szkWWk: "Amérique/Bahia",
  t5CPbZ: "Europe/Dublin",
  tHE78L: "Amérique/Saint-Domingue",
  tMDDnr: "Amérique/Managua",
  tUaF1F: "Pacifique/Niue",
  tlkIG3: "Pacifique/Fidji",
  "tw/bjJ": "Asie/Novokouznetsk",
  u0TM9W: "Amérique/Port-au-Prince",
  uMXTTe: "Europe/Stockholm",
  uNiOLq: "Asie/Jérusalem",
  "uOkO/r": "Asie/Irkoutsk",
  "utbU0+": "Asie/Achgabat",
  ux1XM2: "Atlantique/Bermudes",
  "v+arTX": "Amérique/Eirunepé",
  vMATTy: "Asie/Damas",
  "vWWiU+": "Asie/Pyongyang",
  vbHpIo: "Afrique/Windhoek",
  vn9nKr: "Amérique/Porto_Velho",
  vohVUs: "Asie/Kaboul",
  vwtvCc: "Atlantique/Cap-Vert",
  vy4zY8: "Asie/Colombo",
  w7kHCL: "Atlantique/Madère",
  wDFHDz: "Amérique/Martinique",
  "wbQai/": "Atlantique/Géorgie du Sud",
  wrZg4b: "Asie/Thimphou",
  xAcBeP: "Pacifique/Tahiti",
  xKA8d6: "Antarctique/DumontDUrville",
  "xx+5iB": "Amérique/Kentucky/Louisville",
  y79PlA: "Asie/Amman",
  yaBGO1: "Pacifique/Pitcairn",
  yeltlL: "Océan Indien/Mahé",
  ygabsP: "Amérique/North_Dakota/New_Salem",
  z6KEn9: "Pacifique/Rarotonga",
  z98zna: "Océan Indien/Kerguelen",
  zWABd8: "Europe/Belgrade",
  zm3ZI2: "Asie/Shanghai",
  zwjmMl: "Asie/Katmandou",
  "e5x+i6": "Australie/Lord_Howe",
  gAtxKw: "Antarctique/Macquarie",
  P5aTR8: "Australie/Hobart",
  "nFhe/c": "Australie/Currie",
  e6YJm8: "Australie/Melbourne",
  dmcxmV: "Australie/Sydney",
  jFnCUr: "Australie/Broken_Hill",
  i5MwAy: "Australie/Brisbane",
  WyjEwT: "Australie/Lindeman",
  JuasJd: "Australie/Adélaïde",
  co8c88: "Australie/Darwin",
  qm4oIk: "Australie/Perth",
  "0LrMZs": "Australie/Eucla",
  "+E914Q": "Français (La Réunion)",
  "+FHEub": "Tamazight du Moyen Atlas (Arabe)",
  "/AAqs8": "Portugais (Guinée équatoriale)",
  "/BbMQN": "Cinghalais",
  "/NVZFV": "Portugais (Angola)",
  "/V7bTl": "Fula (Latin, Gambie)",
  "/YFnxw": "Saho",
  "/stiNv": "Thaï",
  "019rDM": "Portugais (Portugal)",
  "01GXUP": "Fula (Latin, Guinée)",
  "0BWpf+": "Japonais",
  "0CHkPh": "Frison occidental",
  "0D82eT": "Croate (Bosnie-Herzégovine)",
  "0fzUyn": "Portugais",
  "0mDCSY": "Espagnol",
  "0rqbd/": "Maltais",
  "160k/R": "Russe",
  "1BHQDP": "Bengali (Inde)",
  "1F0Uz0": "Arabe (Irak)",
  "1J25kd": "Bosniaque (Slave)",
  "1RqABh": "Lituanien",
  "1dv927": "Malais (Brunei)",
  "29JxAe": "Anglais (Royaume-Uni)",
  "2LBIWM": "Inuktitut",
  "2OXQzm": "Danois",
  "2atqiI": "Oromo",
  "2hRVBA": "Serbe",
  "30RDW+": "Arabe (Qatar)",
  "3PyL86": "Anglais (Philippines)",
  "3Rvul8": "Tibétain (Inde)",
  "3ijo+p": "Néerlandais (Suriname)",
  "4+Zl7y": "Espagnol (Salvador)",
  "4Od9+t": "Serbe (Slave, Bosnie-Herzégovine)",
  "4U3ZpB": "Français (Haïti)",
  "4Xzh0/": "Portugais (Suisse)",
  "4eGD8c": "Fula (Latin, Sierra Leone)",
  "4fkP4F": "Espagnol (Cuba)",
  "4lbmZs": "Espagnol (Philippines)",
  "4v0pnb": "Gallois",
  "51lnU8": "Colognian",
  "5KynFd": "Tchèque",
  "5cyBop": "Anglais (Inde)",
  "5ff1Qr": "Tsonga",
  "5g+4ES": "Coréen (Corée du Nord)",
  "5riLBC": "Somali (Djibouti)",
  "5vu2sQ": "Ouzbek",
  "5xPlEp": "Chinois (Traditionnel)",
  "62eqUV": "Luri du Nord",
  "6AZb8G": "Inuktitut (Programme éducatif)",
  "6G/CAW": "Belge",
  "6am43/": "Kurmanji",
  "6ebNfH": "Chinois (Simplifié, RAS de Hong Kong)",
  "6gtes0": "Tamazight du Moyen Atlas",
  "6sur5u": "Danois (Groenland)",
  "7Gt5UH": "Sanskrit",
  "7k8oo8": "Allemand (Autriche)",
  "7wLEyk": "Mannois",
  "7yHu97": "Letton",
  "8MDM0L": "Tamoul (Sri Lanka)",
  "8oEDHH": "Français (Maroc)",
  "93yDUJ": "Sami du Sud (Norvège)",
  "9cbhiA": "Arabe (Monde)",
  "9ftsGr": "Anglais (Malaisie)",
  "9ltErv": "Romanche",
  "9uEO2O": "Asturien",
  AAf440: "Sesotho sa Leboa",
  ALhR5U: "Quechua (Pérou)",
  "AQfg7+": "Français (Congo - Kinshasa)",
  AahSYM: "Ouzbek (Arabe)",
  AeHTyT: "Anglais (RAS de Hong Kong)",
  "B+59h1": "Mongol (Mongol traditionnel)",
  B8qZTI: "Arménien",
  B9ZGRE: "Lao",
  BFf5tN: "Français (Canada)",
  BgGwdt: "Vietnamien",
  BpUgM5: "Néerlandais (Bonaire, Saint-Eustache et Saba)",
  BtqqJK: "Espagnol (Honduras)",
  CBhHg6: "Fula (Latin, Nigeria)",
  CDbpEz: "Islandais",
  CFRfr5: "Dzongkha",
  CauPny: "Catalan (France)",
  Ccf8zA: "Espagnol (Uruguay)",
  DBHTS0: "Anglais (Australie)",
  DMjlMC: "Allemand (Belgique)",
  DW0c2K: "Espagnol (Chili)",
  DzWKvp: "Géorgien",
  "EP6mL+": "Manipuri",
  EREJay: "Sami (Lule)",
  EeOqFb: "Portugais (Sao Tomé-et-Principe)",
  EzFn0W: "Néerlandais (Aruba)",
  F38yZH: "Somali",
  "FHLC+T": "Allemand (Liechtenstein)",
  Fxzz1N: "Suédois (Finlande)",
  FzgpJw: "Bengali",
  G7wzBO: "Arabe (Émirats arabes unis)",
  "GF/5qr": "Tachlhit",
  GGLJ5z: "Corse",
  GHtHh4: "Maori",
  "GRMM/R": "Alsacien (France)",
  "GZ+vSv": "Syriaque",
  GnC74O: "Tibétain",
  GqQl0h: "Italien",
  GsOiFJ: "Anglais (Afrique du Sud)",
  Gwyv4n: "Pendjabi",
  "H/OHWA": "Filipino",
  H4fFDA: "Sami du Nord",
  H73FDV: "Ouïghour",
  "H7jT/h": "Albanais (Kosovo)",
  HDDkEc: "Zoulou",
  HVCuT9: "Anglais (Allemagne)",
  HZPa57: "Gaélique écossais",
  "Hhe/Ef": "Espagnol (Brésil)",
  Hj8GDj: "Gujarati",
  Hq92CJ: "Hawaïen",
  HqCNsI: "Norvégien",
  "I/+zqv": "Anglais (Guernesey)",
  I42yCw: "Anglais (Canada)",
  IC7HXP: "Tigrigna",
  IDCrtf: "Finnois",
  IEUJ0j: "Allemand (Luxembourg)",
  "IR/BFt": "Somali (Éthiopie)",
  ItGyiB: "Kannada",
  Iz1WLp: "Ourdou",
  J1rnrw: "Slovène",
  J5rPWm: "Espagnol (Équateur)",
  JPFRXM: "Anglais (Malte)",
  JVK3dg: "Allemand",
  JkretN: "Anglais (Finlande)",
  Js4yYb: "Fula",
  "Jsem/p": "Mohawk",
  KDsjWJ: "Tamazight marocain standard",
  "Kj/zcq": "Français (Monaco)",
  LX0RZR: "Fula (Adlam)",
  Laghvq: "Kinyarwanda",
  Ll0N3I: "Cherokee",
  MESBkg: "Xhosa",
  MJQbru: "Bachkir",
  Mbp9v6: "Arabe (Syrie)",
  Mt9Ngn: "Hébreu",
  N4oAho: "Sotho",
  NLZIcM: "Néerlandais (Belgique)",
  NObQUE: "Afrikaans",
  "NV+8r2": "Mapuche",
  NVQG0j: "Divehi",
  Nevbjx: "Fula (Latin, Mauritanie)",
  NfTD2i: "Espagnol (Venezuela)",
  NhbCYP: "Valencien (Espagne)",
  NtuQMz: "Portugais (RAS de Macao)",
  "O/Bw0H": "Serbe (Latin, Kosovo)",
  OKUlj2: "Hongrois",
  OSMagZ: "Français",
  Oju9iC: "Mongol",
  P23feN: "Espagnol (Belize)",
  "P91ei/": "Tadjik",
  PE6jNM: "Espagnol (Argentine)",
  PO8fNg: "Portugais (Timor oriental)",
  POQTzM: "Français (Sénégal)",
  PSoXmh: "Odia",
  Pa7aMt: "Arabe (Liban)",
  Pl3tfG: "Suédois",
  PsNb95: "Irlandais",
  Q8eBZk: "Néerlandais",
  QBwWZp: "Oromo (Kenya)",
  Qcitp4: "Javanais",
  Ql51WU: "Marathi",
  R1VwTR: "Basque",
  R325ks: "Espagnol (Amérique latine)",
  R34HBa: "Arabe (Oman)",
  RRmxSU: "Quechua",
  RTbzBi: "Sorabien supérieur",
  RWrQ2K: "Arabe (Algérie)",
  "RqsM+G": "Espagnol (Nicaragua)",
  SUF5bX: "Anglais (Autriche)",
  Sg9DRE: "Français (Suisse)",
  SlWjJ2: "Sami du Sud",
  T9IHrN: "Luxembourgeois",
  TQ7V9A: "Arabe (Maroc)",
  Tddnlb: "Télougou",
  Tq0aui: "Khmer",
  UAHDtf: "Malayalam",
  UGFi6Q: "Arabe (Jordanie)",
  Uc1vOK: "Albanais",
  "V+BaHn": "Pachto",
  V223G2: "Fula (Latin, Burkina Faso)",
  V2uMRt: "Tamoul",
  VJbQAt: "Espagnol (Panama)",
  VKt1qn: "Népalais (Inde)",
  VuQRaN: "Italien (Suisse)",
  W6zXNX: "Espagnol (République dominicaine)",
  WK7YIm: "Arabe (Yémen)",
  WQtbS0: "Anglais",
  WU7Urn: "Turc",
  WUUTG8: "Turkmène",
  Wlr6BV: "Catalan (Italie)",
  XAmFMw: "Croate",
  XNXAkr: "Quechua (Équateur)",
  XT8v2Z: "Catalan",
  XjbxJQ: "Afrikaans (Namibie)",
  Xkmde4: "Chinois (Simplifié, RAS de Macao)",
  Xx527p: "Sami du Nord (Suède)",
  Y7CQhy: "Allemand suisse",
  Y8mZTh: "Anglais (Jamaïque)",
  Y941O5: "Slovaque",
  YNjb1t: "Féroïen",
  Ygp3rn: "Bosniaque",
  "Z/MVyq": "Slavon d'église",
  ZCh9e6: "Sorabien inférieur",
  ZQtURc: "Roumain (Moldavie)",
  ZjrmiJ: "Shona",
  "Zki/XJ": "Kazakh",
  a9U6ge: "Cornique",
  aO94Wj: "Ourdou (Inde)",
  "aTZE+x": "Cachemiri (Devanagari)",
  aiXFTk: "Fula (Latin, Ghana)",
  bDNNJp: "Malais (Indonésie)",
  bLqBa4: "Anglais (Nouvelle-Zélande)",
  bRIPjy: "Anglais (Israël)",
  "bT+IsS": "Malais (Singapour)",
  bVuD3F: "Arabe",
  bfp8tQ: "Groenlandais",
  c3rP5p: "Anglais (Slovénie)",
  cJbw13: "Chinois (Traditionnel, Taïwan)",
  cQRIur: "Anglais (Singapour)",
  d5MtIX: "Indonésien",
  dEIOuD: "Polonais",
  dPzT2w: "Breton",
  drEx3O: "Swahili",
  e9Fovw: "Papiamento",
  eGmwHh: "Anglais (Suisse)",
  eSg76K: "Anglais (Gibraltar)",
  eSmbEf: "Irlandais (Royaume-Uni)",
  eWnJnC: "Hindi",
  efy66J: "Tchétchène",
  "f+NB92": "Espagnol (Pérou)",
  "f/8iNS": "Fula (Latin, Cameroun)",
  "f5+iem": "Espagnol (Mexique)",
  f6Viji: "Pachto (Pakistan)",
  fkHabQ: "K'iche'",
  fv9aDa: "Sami (Inari)",
  "gHco+M": "Russe (Moldavie)",
  gOsLMk: "Malgache",
  gWx9ey: "Serbe (Latin, Monténégro)",
  gfmlPE: "Anglais (Irlande)",
  glnMAY: "Tachlhit (Latin)",
  gvaI7A: "Somali (Kenya)",
  "h6q+Tn": "Prussien",
  h9YX8r: "Tamoul (Singapour)",
  "hEPDg/": "Occitan",
  hNSwvJ: "Fula (Latin, Libéria)",
  hcX72z: "Tamoul (Malaisie)",
  hmzrxz: "Sami du Nord (Finlande)",
  hr7Bt0: "Portugais (Guinée)",
  i4jvwu: "Chinois",
  "i5/TH8": "Espagnol (Guinée équatoriale)",
  "iI431+": "Anglais (Pays-Bas)",
  iKxsEO: "Népalais",
  iTiaM1: "Guarani",
  iXn58z: "Azéri (Slave)",
  ifdXl3: "Coréen",
  jG6ZfL: "Allemand (Italie)",
  jGXHMX: "Serbe (Latin, Bosnie-Herzégovine)",
  "jHvE/3": "N'Ko",
  joVZ4M: "Arabe (Égypte)",
  "k+bU6l": "Néerlandais (Saint-Martin)",
  k6RCbu: "Portugais (Luxembourg)",
  kW1ixl: "Swahili (Ouganda)",
  l8f1rC: "Cachemiri",
  lGAoQJ: "Swahili (Tanzanie)",
  "lig/ia": "Bodo",
  lwerC3: "Espagnol (États-Unis)",
  "m+zQs1": "Igbo",
  m421XM: "Ukrainien",
  "mP+2ZR": "Anglais (Trinité-et-Tobago)",
  mQ30Fl: "Anglais (Îles Malouines)",
  mQPNAb: "Sindhi",
  mgFsmM: "Anglais (Danemark)",
  "mkyn/R": "Arabe (Bahreïn)",
  mq4oU3: "Anglais (Jersey)",
  mvxq4r: "Galicien",
  n86rIs: "Kirghize",
  naThLg: "Grec",
  ncJAOw: "Birman",
  nfKkEe: "Fula (Latin, Niger)",
  nzfKPJ: "Français (Cameroun)",
  "oCgi+u": "Amharique",
  "oh7xe+": "Sami (Lule, Norvège)",
  oiHWuC: "Allemand (Suisse)",
  ono6Zw: "Espagnol (Guatemala)",
  ouSGKF: "Sami (Skolt)",
  pJE11U: "Setswana (Botswana)",
  pVxDdM: "Mazandarani",
  pcWfuB: "Setswana",
  pdfcvu: "Français (Côte d'Ivoire)",
  pjF6Nn: "Sotho (Lesotho)",
  pqIrOS: "Arabe (Tunisie)",
  q2N4yn: "Serbe (Slave)",
  qQDW8M: "Français (Mali)",
  qRbMrx: "Yoruba",
  qYdUNv: "Tamazight du Moyen Atlas (Tifinagh)",
  qu9gJ5: "Arabe (Libye)",
  qwSYAN: "Portugais (Mozambique)",
  r8ZWqf: "Nynorsk norvégien",
  rcixhA: "Néerlandais (Curaçao)",
  rcmyN3: "Persan (Afghanistan)",
  rk5DA1: "Anglais (Belgique)",
  sBC8AY: "Sindhi (Devanagari)",
  sHbxv8: "Anglais (Belize)",
  sRuB7H: "Malais",
  sl0qaQ: "Arabe (Koweït)",
  sliV2n: "Espagnol (Paraguay)",
  syMU2g: "Français (Belgique)",
  tQJpug: "Catalan (Sardaigne)",
  tQi27b: "Konkani",
  tRgqyZ: "Serbe (Slave, Kosovo)",
  tdrfAE: "Anglais (Caraïbes)",
  u0KReQ: "Italien (Cité du Vatican)",
  u61cWR: "Espagnol (Colombie)",
  u78bW4: "Macédonien",
  uCI04p: " estonien",
  uVRPPZ: "Tatar",
  ubfX8q: "Anglais (Zimbabwe)",
  uh1OQN: "Wolof",
  upv4s2: "Portugais (Cap-Vert)",
  vSG3D5: "Espagnol (Costa Rica)",
  viRRMu: "Serbe (Slave, Monténégro)",
  vo99Cy: "Anglais (Burundi)",
  vuf8EY: "Anglais (Îles Vierges britanniques)",
  vxR1y4: "Haoussa",
  wVqnrV: "Persan",
  wra0CG: "Swahili (Congo)",
  wtZRFn: "Frioulan",
  x0KMJr: "Anglais (Île de Man)",
  xXkK79: "Mongol (Mongol traditionnel)",
  xeXtGt: "Anglais (Suède)",
  xgB0JY: "Assamais",
  xoMuR7: "Walser",
  "xzWaZ/": "Espagnol (Porto Rico)",
  "y//NHV": "Azerbaïdjanais",
  y7nOlh: "Bulgare",
  ydTOo2: "Français (Luxembourg)",
  z0tSbC: "Ossète",
  z1VBi8: "Roumain",
  zBWf5p: "Interlingua",
  zWU1xI: "Espagnol (Bolivie)",
  "05KCjo": "Icône de l'application：",
  "11uVJ/": "Recevoir l'objet",
  "1Qoc6t": "Nom du processus :",
  "2JW1Pt":
    "Veuillez choisir si vous souhaitez envoyer des e-mails en même temps",
  "70JpVD": "Nom du processus",
  "9AsSO/": "Veuillez choisir si vous souhaitez envoyer des SMS en même temps",
  "AH+jWQ": "Application Windows",
  Axagls: "Veuillez sélectionner une heure de fin",
  FNIJXx: "Veuillez sélectionner la lecture avec défilement",
  Fir0oq: "Veuillez sélectionner le type de notification",
  G4qgGm: "Tous les utilisateurs",
  G5gg2V: "Le titre de l'annonce est obligatoire",
  IWPf2S: "Détails de l'annonce",
  IbWDVg: "Numéro de version requis",
  Km733q: "Veuillez sélectionner une heure de début",
  L24ioQ: "Titre",
  L80hmc: "Le titre de l'annonce ne doit pas dépasser 30 caractères",
  NDjXUx: "Entrez la commande pour déployer le fichier :",
  "Oex59+": "Liste de retour",
  QHc9Qg: "Contenu de l'annonce",
  QNomO6: "Veuillez saisir le numéro de version",
  Qpcx6F: "Le contenu de l'annonce est obligatoire",
  RQyKsa: "Annonce de la plateforme",
  TiK9WZ: "Le nom du processus est requis",
  TvOGLc: "Commande du fichier de déploiement",
  UHuNzJ: "Veuillez entrer la commande",
  WtPk7v: "Envoyer des SMS simultanément",
  XbIN5K: "Veuillez entrer le nom du programme",
  XeIKK7: "Centre de notifications",
  ZqioaF: "Titre de la notification",
  aGxRt2: "contenu",
  cr1ymH: "Veuillez sélectionner l'heure d'envoi",
  dY3og7: "Icône de téléchargement de l'application :",
  eFDqHN: "Télécharger l'application Windows avec succès",
  eSfTZf: "Télécharger une application Windows",
  "ghKe/+": "nom du processus",
  "h5yj+x": "Veuillez saisir le nom du processus",
  jAJbuk: "Annonce de notification",
  l36W55: "Lecture par défilement",
  lqQKL4: "Ajouter par nom de processus",
  mKKd1R: "Veuillez sélectionner les destinataires",
  q9PHLT: "Aucune annonce pour l'instant",
  wYygRu: "Expéditeur",
  xXdMar: "Utilisateur spécifié",
  xx40g7: "Titre de l'annonce",
  yKFvYY: "Envoyer des emails simultanément",
  yfhtRM: "Pièce jointe",
  z5L9EV: "Mettre à jour les applications Windows",
  "bhv+8O": "Téléchargement",
  xzmRTb: "Afficher uniquement l'historique des 7 derniers jours",
  "yrR/HC": "Installation",
  ibYzs0: "Nom du programme : {name}",
  ivzCMK: "L'application ne peut pas être analysée.",
  mJBhe1:
    "La synchronisation des fichiers permet d'ajouter jusqu'à 10 fichiers",
  "6oXjFu": "Le format de téléchargement est incorrect",
  KetfTt: "Taille maximale de l'image : 500 Ko",
  baNBmh: "La taille de l'image ne peut pas dépasser 500 Ko",
  tAjFr2: "Formats d'images : PNG, JPG, JPEG, BMP, GIF, SVG, WEBP",
  "3K02K/": "Configuration wifi incomplète",
  "5Cm9U3": "Notification de message",
  "Y6Q+iJ": "Veuillez renseigner la configuration wifi",
  tugHWJ: "Retour à la liste des annonces",
  "x/FhNQ": "Afficher les notifications",
  "+GRUnH": "Asie/Khovd",
  "+IL2pH": "Asie/Riyad",
  "+J2Dyk": "Amérique/Asuncion",
  "+Ny8AK": "Amérique/Puerto_Rico",
  "+RWig5": "Espagnol (Bolivie)",
  "/2Wzyw": "Amérique/El_Salvador",
  "/rG/9z": "Amérique/Curaçao",
  "0AuprP": "Pacifique/Tongatapu",
  "0X3KFO": "Température du CPU",
  "0vIw5o": "Amérique/Bogotá",
  "1YfhFP": "Asie/Dili",
  "2+A7qs": "Antarctique/Mawson",
  "2+ec6P": "Amérique/Danmarkshavn",
  "2FPNxz": "Asie/Dubaï",
  "32RJkL": "Amérique/Argentine/San_Luis",
  "33VS8L": "Amérique/Maceió",
  "36csPo": "Europe/Zurich",
  "3KlQfs": "Australie/Brisbane",
  "3LAnU7": "Atlantique/Féroé",
  "3MaR6w": "Europe/Tallinn",
  "3NE037": "Asie/Achgabat",
  "3svavz": "Amérique/Miquelon",
  "42xSxy": "Asie/Novossibirsk",
  "4LAo5S": "Amérique/Metlakatla",
  "4Sw/d9": "Asie/Krasnoïarsk",
  "4T/bEM": "Amérique/Indiana/Vevay",
  "4WaJo8": "Amérique/Scoresbysund",
  "4Wgk5f": "Europe/Andorre",
  "4ZRHuu": "Atlantique/Géorgie_du_Sud",
  "4cXOI/": "Asie/Erevan",
  "4jryq3": "Amérique/Dakota_du_Nord/New_Salem",
  "4sqSH4": "Asie/Khandyga",
  "564gFy": "Afrique/Accra",
  "6SQvm5": "Asie/Pontianak",
  "6X6msx": "Utilisation du stockage",
  "6xnHrJ": "Europe/Berlin",
  "72KWoU": "Australie/Sydney",
  "778/Xc": "Amérique/Tegucigalpa",
  "7JA1Vf": "Amérique/Argentine/Mendoza",
  "7L+CJm": "Europe/Helsinki",
  "7geAkY": "Amérique/Argentine/Buenos_Aires",
  "7teo40": "Pacifique/Chuuk",
  "87d7yX": "Pacifique/Guadalcanal",
  "8Gi8qJ": "Australie/Broken_Hill",
  "8eL/hC": "Asie/Jérusalem",
  "8hJsOE": "Asie/Bangkok",
  "8qYKWy": "Pacifique/Chatham",
  "8woxjy": "Asie/Kuala_Lumpur",
  "A3y/jB": "Amérique/Argentine/Río_Gallegos",
  ACHtOA: "Asie/Kamchatka",
  AFZYEo: "Asie/Brunei",
  ALGNzc: "Asie/Magadan",
  AWhHY3: "Amérique/Rio_Branco",
  ApnLV0: "Asie/Almaty",
  AqKGKn: "Asie/Jakarta",
  As1lP0: "Indien/Kerguelen",
  "Aytpe/": "Europe/Monaco",
  B6rikn: "Amérique/Indiana/Indianapolis",
  B9NkmN: "Europe/Luxembourg",
  BXdJNy: "Atlantique/Stanley",
  BgYCgo: "Antarctique/Casey",
  C21hEn: "Europe/Belgrade",
  C7HjWu: "Europe/Amsterdam",
  CBkGYl: "Afrique/Maputo",
  CC9Jw3: "Asie/Makassar",
  CIImWq: "Pacifique/Majuro",
  "CNMmH/": "Asie/Yakoutsk",
  CR8w2m: "Amérique/Grand_Turk",
  CUsFOe: "Amérique/Cayenne",
  D2gXtv: "Amérique/Menominee",
  D4VBw5: "Antarctique/Dumont_d'Urville",
  DincSy: "Australie/Lord_Howe",
  DoPuye: "Asie/Damas",
  "E/3oPZ": "Asie/Macao",
  E2NUw6: "Afrique/Johannesburg",
  EJA24j: "Pacifique/Norfolk",
  EgGVTj: "Pacifique/Enderbury",
  EhPWhM: "Amérique/Cuiabá",
  EmxcJt: "Amérique/Yakutat",
  Ewhh7n: "Europe/Sofia",
  FXD37C: "Amérique/Panama",
  FsXquv: "Asie/Pyongyang",
  GIHcco: "Amérique/Nuuk",
  GIwuGT: "Europe/Bruxelles",
  GNkv6K: "Afrique/El_Aaiún",
  "H8+X66": "Asie/Khandyga",
  HDVqMh: "Amérique/Argentine/San_Juan",
  HEpXP8: "Amérique/Denver",
  HOEyDX: "Amérique/La_Paz",
  HS4Jyv: "Europe/Oujhorod",
  Hh1tUP: "Amérique/Guayaquil",
  HkGIFU: "Antarctique/Davis",
  HoSy6c: "Pacifique/Kwajalein",
  HuSwkp: "Asie/Oust-Nera",
  HzSbcD: "Antarctique/Troll",
  I3bX6d: "Asie/Ouloumtsi",
  IBZBgD: "Europe/Istanbul",
  IHXrCK: "Amérique/Los_Angeles",
  IKeroX: "Asie/Jayapura",
  ILjenb: "Amérique/Indiana/Marengo",
  IgbKn9: "Asie/Ho_Chi_Minh",
  InLlSF: "Amérique/Paramaribo",
  J5iABC: "Asie/Karachi",
  JHjx5l: "Amérique/Anchorage",
  "JURm/W": "Antarctique/Palmer",
  "Jc5/LG": "Asie/Omsk",
  JrjIBq: "Amérique/Port-au-Prince",
  K9TF6H: "Asie/Hong_Kong",
  KAKu2d: "Pacifique/Nouméa",
  KEr7iI: "Pacifique/Palau",
  "KaS+yS": "Amérique/Costa_Rica",
  KyBesr: "Pacifique/Rarotonga",
  M3Bd2i: "Pacifique/Pitcairn",
  MAVhWe: "Europe/Oslo",
  MAWdwn: "Asie/Colombo",
  McxhaP: "Amérique/Belize",
  MeSuny: "Amérique/Barbade",
  MmTr9O: "Afrique/Le_Caire",
  Mr4JiU: "Indien/Chagos",
  MxWLCa: "Pacifique/Marquises",
  NW4CG5: "Afrique/Tripoli",
  NWpmvK: "Europe/Moscou",
  Nd0dlz: "Amérique/Argentine/Catamarca",
  NhHERf: "Afrique/Khartoum",
  O2VzkZ: "Europe/Gibraltar",
  OEWR5m: "Amérique/Récife",
  OPvCOV: "Atlantique/Reykjavik",
  OdITFl: "Indien/Cocos",
  Oj7H2e: "Europe/Malte",
  OnT6Rq: "Amérique/Argentine/Salta",
  P5ijks: "Asie/Tchita",
  P8Gz8g: "Asie/Samarcande",
  P8fuMA: "Pacifique/Apia",
  PE4Jv1: "Europe/Kaliningrad",
  "PHe5b/": "Amérique/São_Paulo",
  PQTASm: "Afrique/Nairobi",
  PSTE5v: "Asie/Téhéran",
  "Pr/HJJ": "Amérique/Thulé",
  Q93ucv: "Europe/Dublin",
  Q9eZjv: "Amérique/Lima",
  QIrZ4x: "Pacifique/Kosrae",
  QXW2mv: "Amérique/Argentine/Tucumán",
  QlNyHt: "Asie/Séoul",
  RWGdDh: "Europe/Bucarest",
  RWhf30: "Pacifique/Auckland",
  RbCEhx: "Amérique/Kentucky/Louisville",
  RdB8rs: "Amérique/Kentucky/Monticello",
  Ri5GFC: "Europe/Volgograd",
  Rzjtg0: "Antarctique/Macquarie",
  "SB+r6t": "Indien/Christmas",
  "SDmnE+": "Asie/Amman",
  SO2rVX: "Afrique/Windhoek",
  TSIb1O: "Asie/Beyrouth",
  TVzP2K: "Pacifique/Île_de_Pâques",
  TmXGJf: "Pacifique/Pago_Pago",
  Tp6vAo: "Atlantique/Açores",
  "Tvk1/+": "Asie/Bakou",
  TxnfAW: "Europe/Simferopol",
  UU6RxP: "Pacifique/Fakaofo",
  "W+BF0N": "Europe/Kiev",
  WF6jLL: "Asie/Irkoutsk",
  WGbNbT: "Europe/Rome",
  WH83gM: "Australie/Eucla",
  WM9F6N: "Europe/Budapest",
  WT4u2Q: "Afrique/Bissau",
  Wd588a: "Amérique/Juneau",
  "X+krOQ": "Europe/Londres",
  XG3VTC: "Indien/Maldives",
  XGLQKt: "Indien/Maurice",
  XJz9XQ: "Amérique/Chicago",
  XcLHzQ: "Amérique/Saint-Domingue",
  XgCqrC: "Asie/Kuching",
  "Xs2qb/": "Asie/Shanghai",
  YUT4gj: "Europe/Lisbonne",
  YZ2GGD: "Asie/Singapour",
  "Ywxpi/": "Indien/Mahé",
  Z0uRcM: "Asie/Dacca",
  ZKdJhk: "Amérique/Boa_Vista",
  ZZib2d: "Australie/Hobart",
  Zjiy1h: "Pacifique/Nauru",
  ZnA7Nz: "Asie/Hébron",
  a25tfu: "Asie/Calcutta",
  a4hALt: "Europe/Samara",
  aIkFIc: "Europe/Riga",
  aJXo8B: "Asie/Sakhaline",
  an8KV9: "Europe/Stockholm",
  "bPKD9+": "Amérique/Bahia",
  bpugpH: "Pacifique/Galápagos",
  bwibOg: "Amérique/Indiana/Tell_City",
  bwxucD: "Antarctique/Rothera",
  byIMHD: "Amérique/Indiana/Winamac",
  cGo7xU: "Europe/Vienne",
  cL4iBR: "Pacifique/Wake",
  cR6lQr: "Amérique/New_York",
  cY9R69: "Asie/Rangoun",
  "cdP+DQ": "Charge de mémoire",
  cfqioE: "Amérique/Martinique",
  ckkIgb: "Amérique/Santarém",
  "d+p45H": "Antarctique/Station",
  "dD/ri/": "Pacifique/Efate",
  dVOPAi: "Surveillance de l'appareil hors ligne",
  dmQidl: "Pacifique/Wallis",
  dnhrx5: "Europe/Athènes",
  dsc2e1: "Amérique/Campo_Grande",
  dwtkZ7: "Atlantique/Cap-Vert",
  e7x56t: "Amérique/Eirunepe",
  eCaCt4: "Europe/Copenhague",
  eJ850A: "Amérique/Caracas",
  eUPrSB: "Amérique/Argentine/Córdoba",
  "eiH+8b": "Afrique/N'Djamena",
  esrASO: "Amérique/Manaus",
  "f/kdJq": "Asie/Douchanbé",
  f2wvqe: "Asie/Qyzylorda",
  fRTjpp: "Amérique/Port-d'Espagne",
  felOXC: "Europe/Minsk",
  "fr++q+": "Amérique/Dakota_du_Nord/Centre",
  fwXmSX: "Indien/Réunion",
  g8yytK: "Lu",
  g9Ro8s: "Asie/Thimphou",
  gCnWv3: "Amérique/Guatemala",
  "gWP+OK": "Amérique/Porto_Velho",
  gY9Idz: "Contenu de la notification",
  hMJvQy: "Asie/Aqtobe",
  hMvFT8: "Pacifique/Fidji",
  i9kfO3: "Australie/Perth",
  ia2KGW: "Australie/Lindeman",
  iemojj: "Amérique/Indiana/Petersburg",
  iktlFx: "Afrique/Lagos",
  ioR1tU: "Australie/Melbourne",
  irTGxZ: "Amérique/Nassau",
  iuG5L2: "Pacifique/Funafuti",
  jArote: "Asie/Choibalsan",
  jGg3Qb: "Atlantique/Bermudes",
  "kPnKK/": "Pacifique/Tarawa",
  kQfkBY: "Pacifique/Niue",
  kX80z5: "Afrique/Casablanca",
  kb4vnt: "Asie/Tbilissi",
  kibwvT: "Amérique/Araguaina",
  klPlFN: "Atlantique/Madère",
  ktaxSw: "Non lu",
  kzL66g: "Amérique/Sitka",
  l0DTVX: "Europe/Chisinau",
  l3HZXk: "Amérique/Argentine/Jujuy",
  lUObgG: "Asie/Novokouznetsk",
  "lY+G1f": "Europe/Zaporijia",
  ldw5JF: "Amérique/La_Havane",
  ldz3Qp: "Amérique/Nome",
  "luv+ak": "Antarctique/Showa",
  m372k4: "Asie/Aqtau",
  mC90qt: "Amérique/Fernando_de_Noronha",
  maWrSV: "Asie/Qatar",
  mpmcYh: "Amérique/Jamaïque",
  mzw9vO: "Asie/Vladivostok",
  nFRGgT: "Asie/Nicosie",
  nG6bDa: "Pacifique/Pohnpei",
  nNIaxy: "Australie/Currie",
  "nTx/do": "Afrique/Monrovia",
  ndfOI1: "Asie/Tachkent",
  nfV4cd: "Pacifique/Port_Moresby",
  nt7Sni: "Amérique/Phoenix",
  "oNgMl/": "Europe/Varsovie",
  ox9xcC: "Asie/Oulan-Bator",
  "p/Y+A9": "Asie/Oral",
  p60kqM: "Amérique/Indiana/Knox",
  "pDAAq+": "Pacifique/Christmas",
  "pH7u/B": "Europe/Prague",
  pctdGN: "Pacifique/Tahiti",
  pkQvvT: "Asie/Gaza",
  qZesUE: "Pacifique/Bougainville",
  qm1rPH: "Amérique/Adak",
  qrxb3P: "Amérique/Managua",
  qyspJO: "Asie/Bagdad",
  rB8hza: "Amérique/Boise",
  rDnYpj: "Amérique/Détroit",
  "rSU+yK": "Europe/Tirana",
  rhrAj5: "Asie/Manille",
  sCbQzB: "Pacifique/Guam",
  ssEhAp: "Australie/Darwin",
  tGy5jw: "Asie/Bichkek",
  tb5CXr: "Europe/Paris",
  u8OEeb: "Asie/Anadyr",
  umaIEg: "Amérique/Argentine/Ushuaïa",
  "uq/hF0": "Asie/Tokyo",
  v1R8a6: "Amérique/Guyane",
  v9QImt: "Asie/Kaboul",
  vvPXpH: "Asie/Katmandou",
  w6MqYv: "Amérique/Belém",
  "wHl/4A": "Australie/Adélaïde",
  wQ6hxa: "Afrique/Tunis",
  wTov5v: "Amérique/Fortaleza",
  wu6z2j: "Pacifique/Gambier",
  xC5dF9: "Afrique/Alger",
  xV1AHg: "Asie/Ekaterinbourg",
  xV72W5: "Amérique/Santiago",
  "xefyX+": "Amérique/Dakota_du_Nord/Beulah",
  yBB7Af: "Amérique/Argentine/La_Rioja",
  yjTwMp: "Asie/Taïpei",
  yk6eIX: "Pacifique/Honolulu",
  z4BN1R: "Amérique/Cayman",
  zMTRSM: "Charge du CPU",
  zOIpOr: "Amérique/Indiana/Vincennes",
  zooIwl: "Europe/Vilnius",
  "/+bsEl": "Amérique/Monterrey",
  "/Gtqfz": "Amérique/Merida",
  "22S38U": "Amérique/Atikokan",
  "3TyuhP": "Amérique/Ojinaga",
  "3nz5UA": "Afrique/Abidjan",
  "5LGVs8": "Amérique/Inuvik",
  "5hwp3A": "Amérique/Winnipeg",
  "75rZvt": "Amérique/Fort_Nelson",
  B1cpxi: "Amérique/Bahia_Banderas",
  DB1i32: "Amérique/Chihuahua",
  EjYbG7: "Atlantique/Canaries",
  JJlhYG: "Amérique/Moncton",
  JK7opY: "Amérique/Rainy_River",
  JMiQE7: "Amérique/Swift_Current",
  JNgj9q: "Amérique/Vancouver",
  LQs9br: "Amérique/Creston",
  TV0vfT: "Amérique/Hermosillo",
  TtsBNI: "Amérique/Santa_Isabel",
  "V/ychw": "Amérique/St_Johns",
  V3RDY8: "Amérique/Cambridge_Bay",
  WrrSc3: "Europe/Madrid",
  XAJf4I: "Amérique/Yellow couteau",
  Xf2rFn: "Amérique/Mazatlan",
  "YIziP+": "Amérique/Rankin_Inlet",
  Zw6GOE: "Amérique/Regina",
  cvhrwM: "Amérique/Pangnirtung",
  d4TeTf: "Amérique/Whitehorse",
  dS4Q9B: "Amérique/Edmonton",
  dXgU6w: "Amérique/Matamoros",
  damxMJ: "Amérique/Nipigon",
  hrTtyK: "Amérique/Dawson_Creek",
  i7y8PO: "Afrique/Ceuta",
  mYnwj6: "Amérique/Iqaluit",
  mZSYZK: "Amérique/Cancun",
  n4UQqL: "Amérique/Dawson",
  pIep8S: "Amérique/Mexico_City",
  pZHBxH: "Amérique/Resolute",
  puzgCP: "Amérique/Toronto",
  sf6FE5: "Amérique/Glace_Bay",
  trLh1J: "Amérique/Tijuana",
  vmXV5r: "Amérique/Blanc-Sablon",
  x062Q4: "Amérique/Halifax",
  x5t5ol: "Amérique/Thunder_Bay",
  x8MKpa: "Amérique/Goose_Bay",
  qhku2P: "(Windows 7 n'est pas encore pris en charge)",
  LjaYAu:
    "(L'appareil redémarrera automatiquement après avoir appliqué les paramètres)",
  SsOQaU: "Le chemin de l'appareil Android doit être défini",
  ftJgyV: "Un périphérique doit être vérifié",
  tp71Dv: "Le chemin du périphérique Windows doit être défini",
  "+x/2kt": "Règles de l'appareil",
  "781mpm": "3. Règles de dénomination par défaut de l'entreprise",
  EJYMZz:
    "Après la fermeture, vous pouvez télécharger la nouvelle version d'Ora et l'installer vous-même, ou la mettre à jour manuellement via la commande de périphérique-Ora update.",
  QWNGGT: "Quantité d'appareil",
  QkSHo2:
    "Après avoir désactivé les mises à jour automatiques, les différences entre les versions d'Ora sur l'appareil peuvent entraîner l'indisponibilité de certaines fonctions",
  RFear4: "2. Période de mise à jour de l'appareil (heure locale)",
  VUYwkz: "Veuillez sélectionner une application",
  Z8Wkvb:
    "Après l'avoir allumé, Ora sera automatiquement téléchargé et mis à jour s'il y a une nouvelle version.",
  bc4BgP: "Dernière fois en ligne",
  c5daOt: "Nombre de magasins ({num})",
  qDHqff: "Redémarrage automatique",
  zbqD5q: "valeur",
  FtTdh0: "1. {ora} se met automatiquement à jour",
  Em0SLE: "Redémarrer",
  Gvm3Ry:
    "Êtes-vous sûr de vouloir redémarrer {appName} de ({name}) ? La surveillance des applications continuera après le redémarrage.",
  Ixi8kg: "Rappel de redémarrage",
  bbMhTk: "Etes-vous sûr de vouloir redémarrer ?",
  "99tjyG": "IP",
  "9a/nvJ": "Résultat de l'opération",
  BdDDD0: "Journal du périphérique",
  MbqxKj: "Nom du modèle",
  OjLqmy: "Inconnu",
  V6d4dz: "Détails de l'opération",
  "hD/l+2": "Type d'opération",
  "s+OQvW": "Opérateur",
  yc8eep: "Sélectionner les résultats",
  "/5RjKG": "Expiration du token",
  "0nwYmb": "Tous les types de notifications",
  "ZC7J/S": "Type de notification",
  pm5kAg: "Contenu s'il vous plaît voir dans les détails",
  y8e4w8: "Prend effet uniquement après le redémarrage de l'appareil",
  vjxfR4: "(Programme d'installation exe, fichier MSI)",
  "8DORrA": "Port USB",
  AFx0WP: "Type de recherche",
  GyqBiS: "Informations sur l'impression",
  L3HWwz: "Description de l'appareil",
  OuXnTb: "Êtes-vous sûr de vouloir réinitialiser ce port USB ?",
  "QZM++f": "Êtes-vous sûr de vouloir réinitialiser l'imprimante ?",
  RCjVsb: "ID de l'appareil",
  RJpihQ: "Êtes-vous sûr de vouloir désactiver ce port USB ?",
  adMZWx: "Ajouter des périphériques",
  j3iWkN: "L'imprimante ne peut pas être répétée",
  kL3ndq: "Voulez-vous supprimer cette imprimante ?",
  r8lAlx: "Gestion des périphériques",
  wIFJtf: "Non connecté",
  zKsJJS: "Êtes-vous sûr de vouloir activer ce port USB ?",
  "zY36V+": "Connecté",
  "2Rco7+": "Heure de téléchargement :",
  "5JrKIs":
    " Le déploiement de la fonctionnalité a été planifié pour l'heure de publication sélectionnée. ",
  E62yo0: "Le déploiement de la fonction a échoué, nouvelle tentative.",
  HI9nIp: "Supprimer les fichiers",
  IX5jed: "État du déploiement du fichier de configuration",
  Mxw3XE: "Le fichier bat n'est pas nommé install ou uninstall",
  "N3h+Aq": "Le déploiement de la fonction a échoué",
  N9kr00: "Désinstaller l'application après le transfert",
  "OY+bYK": "Confirmer, ne plus l'afficher",
  PZD5BD:
    "Ce projet a été utilisé par le fichier de configuration [{name}] et ne peut pas être supprimé. Si vous souhaitez supprimer le projet, veuillez le supprimer du fichier de configuration",
  Pzsa4g: "Le déploiement de la fonction est prêt",
  RzXkm3: "Liste noire activée",
  SzN0Xf: "Supprimer le propriétaire de l'appareil",
  VvutjQ: "Fonction",
  XPoLPc:
    "Le déploiement de la fonction a été reçu et sera traité prochainement.",
  Xsx53E: "Êtes-vous sûr de vouloir supprimer ce fichier ?",
  c7ABGP: "Le déploiement de la fonction attend la réponse d'Ora",
  d6mNdO: "Liste blanche activée",
  f9tP6e: "Êtes-vous sûr de vouloir supprimer cette application Windows ?",
  hmCei2: "Désinstaller l'application après la suppression",
  ii1TCF:
    "(Veuillez nommer le fichier bat dans le package compressé comme install ou uninstall)",
  mmGD7U: "Le déploiement de la fonction est en cours.",
  uL4MGN: "Êtes-vous sûr de vouloir supprimer cette application Android ?",
  wzPSgE: "Liste noire/Liste blanche",
  xAk1ic: "La fonctionnalité a été déployée avec succès",
  yWzW01: "(installateur exe, fichier msi, package compressé zip)",
  yvnu2T: "Nom du modèle de configuration",
  "CqT/5i":
    "Ce fichier a été partagé. Etes-vous sûr de vouloir supprimer ce fichier ?",
  wboZY3: "Heure du rapport",
  "6kNt8v": "L'heure suivante",
  Rkh3mc: "Dernière heure",
  "+/nbWD": "Prochaine heure modifiable {time}",
  "1ULJr+": "Mode application unique",
  CxuMXm: "Ajout d'une application obligatoire",
  Gp3iu0: "Télécharger un fond d'écran local",
  M0GExq:
    "Si l'appareil possède déjà l'application, supprimez la version d'origine et réinstallez-la",
  OYWCEU: "Télécharger l'application locale",
  PyHYs3: "Fermer la connexion VNC",
  QZCAIP: "ID de l'application",
  "X+8ega": "Sélection du mode kiosque",
  "bLP2/B": "Vérifier l'état de l'application de configuration",
  bneXBI: "Modifier l'invite",
  czLSET: "Ajouter manuellement une application",
  eg9Cwk: "Depuis l'entreprise de localisation actuelle",
  f8ijF3: "La commande a été émise",
  i8wqAy: "Télécharger l'application locale",
  oiRBSj:
    "Après confirmation, l'appareil appliquera la nouvelle Paramètres. Voulez-vous vraiment l'appliquer?",
  "qG2/EZ": "Téléchargement de fichiers local",
  "qH+vs7": "Liste blanche",
  qTgFpp: "De l'entreprise à laquelle appartient le compte",
  qwHBkg:
    "Aucune trace des modifications de paramètres; tous les appareils utilisent les paramètres par défaut",
  sB85Wu: "Téléchargement local",
  uqEE8V: "Cette configuration est uniquement applicable à Android Ora 2.14.25",
  vtUGfp: "Règles de dénomination par défaut de l'entreprise",
  QgHuyM: "Règles de dénomination des magasins",
  "+Bas2b": "Durée : {durée}",
  "+a6DnG": "En cours de révision",
  "/CFd+q": "Ouvert",
  "0JQoTX": "Échec de la révision",
  "0Ru5zG": "Taille : {taille}",
  "0UhE3z": "État de lecture",
  "0btyN9": "Durée :",
  "1/U2kj": "Vidéo",
  "1qoi3T": "Image",
  "3HqLlX": "Nouveau contenu",
  "4jU7ke": "Démarrer le lecteur de contenu",
  "4nG/GN": "Nom du contenu",
  "5RR9aM": "Pause du lot",
  "5XSNyG": "Contenus téléchargés avec succès",
  "6K/a0B": "Pause",
  "6wAcmz": "Veuillez sélectionner l'heure",
  "7M1nFY": "Confirmez-vous la suppression du modèle ? {name} ?",
  "7OW60G": "Effacer la sélection horaire",
  "7Ouq4k": "Ordre : {sort}",
  "7cAtfM": "Heures",
  "7wofGo": "Application",
  "9c8SPP": "Taille",
  BhWZJo: "Nom de la ressource",
  C55Kjj: "Contenu à lire",
  "D+32Ow": "Centre de gestion des ressources",
  EBMdAL: "Créé avec succès",
  ECm6hH: "Voulez-vous vraiment supprimer cette ressource ({name}) ?",
  "ELFG/t": "Rechercher un appareil",
  IP9Kbk: "Les images ne peuvent pas dépasser 15 Mo",
  Ie9WHB: "Télécharger du contenu",
  KOVFgK: "En attente de vérification",
  "Lqca+c": "Changement de lecteur",
  MDACCo: "Lecture réussie",
  MWJG8I: "Nom : {name}",
  "Ut8+i2": "Approuvé",
  "Xi/+KE": "Ajouter un créneau horaire",
  YuZxve: "Sélectionner le contenu",
  bKLb1C: "Lecture",
  bYujGa: "Créer un modèle",
  fFaC3Z: "Heure de lecture",
  gVXoXc: "Gestion du contenu",
  i9lOCU: "La date de début sélectionnée est antérieure à aujourd'hui",
  iHQiQV: "Lecture par lots",
  iJIOBp: "Échec de l'analyse",
  "iRR+fJ": "debugInfo",
  l9XE8F: "Réussi",
  lchpP8: "Application réussie",
  m8CFrl: "Créer un nouveau modèle",
  nbp4U6: "Liste des modèles de contenu",
  oUgWVb: "Type : {type}",
  "p/EHrl": "La taille maximale de la vidéo ne peut pas dépasser 10 Go",
  qx5UwR: "Veuillez sélectionner un appareil",
  rBWtYz: "Dernière modification",
  rnpMD3: "Désactivé",
  sux9FA: "Saisir la limite inférieure : 1",
  tRm3bw: "Pause réussie",
  uhTa0i: "Aperçu",
  w1cMGO: "Date de fin",
  ztKQno: "Durée",
  J3dxzb:
    "Nubis prend actuellement en charge les formats d’image JPEG et PNG. Les vidéos doivent être encodées avec le codec H.264. Les formats de fichiers pris en charge incluent MPEG-4 et MOV. Un codec est un logiciel ou un matériel qui compresse les données pour une transmission plus rapide et les décompresse pour les ramener à leur format d’origine. Le codec H.264 est couramment utilisé pour l’enregistrement, la compression et la distribution de contenu vidéo. Un format de fichier vidéo peut contenir un ou plusieurs codecs. Si votre fichier vidéo MOV ou MPEG-4 échoue à la vérification, veuillez vérifier que le codec utilisé pour encoder la vidéo est bien H.264.",
  "M5Vtr/": "Modifier le modèle",
  b1xi4S: "Prévisualiser le modèle",
  kNhfaL: "Voulez-vous vraiment supprimer le modèle ({name}) ?",
  kqgd4D: "Ajouter au moins un temps d’exécution.",
  "36pf2y": "Historique du contenu",
  "3izvEF": "Sélectionner un fichier",
  "9mG+jv": "La taille du fichier dépasse l'espace disponible",
  AlFkwq: "Nombre d'appareils installés",
  C8ZuKU: "Largeur de l'image",
  E0Czos: "Hauteur de l'image",
  I73XLQ: "Axe Y de l'image",
  JbroVc: "Nubis Cast",
  MMqJtu: "Sélectionner une image ou une vidéo",
  "Pv/1oy": "Affichage du contenu",
  Rrwy85: "Créateur",
  T8Y38H: "Fichier image (*.jpg/*.png)",
  VJ7wHx: "Nombre d'appareils à installer",
  WI3Hl5: "Axe Y de la vidéo",
  "Y2Wh/g": "Fichier vidéo (*.mp4/*.mov)",
  "YLvNj+": "À déployer",
  kUbrNT:
    "Veuillez d'abord télécharger le fichier dans le Centre de gestion des ressources. Seuls les fichiers approuvés peuvent être utilisés comme modèles.",
  n997QX: "Hauteur de la vidéo",
  rBD8kj: "Axe horizontal de l'image",
  uCmncQ: "Largeur de la vidéo",
  QwmhEP: "Historique du contenu",
  "8vC+0s": "Vous devez sélectionner un contenu de lecture",
  "jG/AFY": "Après confirmation, l'appareil appliquera la nouvelle configuration et ne pourra plus être modifié dans un délai d'un jour. Voulez-vous vraiment l'appliquer ?",
  "AxZAkZ": "Le contenu numérique téléchargé sur cette plateforme sera automatiquement examiné par le service de modération d'Amazon Rekognition afin de réduire le risque de publication publique. Si l'examen automatique échoue, vous pouvez choisir de le vérifier manuellement ; toutefois, dans ce cas, cette plateforme ne sera pas responsable des conséquences ultérieures.",
  "Oyd/7c": " Approbation manuelle",
  "wyHcKZ": "Rappel d'approbation",
  "32HMy/": "Version de diffusion de {nubis}",
  "IS73A4": "L'heure de début ne peut pas être supérieure à l'heure de fin",
  "jCAPQ2": "Mode de diffusion de {nubis}",
  "sWmzFs": "Dernière mise à jour de {ora}",
  "sctjLN": "Dernière connexion de {ora}",
  "uoBkfP": "État de la dernière mise à jour de {ora}",
  "3yichR": "Dernière modification",
  "d+otpZ": "Version publiée",
  "k30s+D": "Dernière publication",
  "9bgunT": "Lorsque cette option est désactivée, vous pouvez télécharger et installer manuellement la dernière version de {ora}, ou la mettre à jour manuellement via la commande de l'appareil : {ora} update.",
  "Yh8vRi": "Lorsque cette option est activée, le téléchargement et la mise à jour seront automatiques dès qu'une nouvelle version de {ora} sera disponible.",
  "ZO2gEn": "Version de {nubis}.",
  "r+yR7v": "Cast de {nubis}.",
  "uf58G7": "Lorsque les mises à jour automatiques sont désactivées, des différences de version de {ora} sur l'appareil peuvent rendre certaines fonctionnalités indisponibles.",
  "y98D3X": "Axe vertical vidéo"
};
